{
	"dialog.ok": "OK",
	"dialog.cancel": "Cancelar",
	"dialog.confirm": "Aceptar",
	"dialog.close": "Cerrar",
	"dialog.import": "Importar",
	"dialog.save": "Guardar",
	"dialog.discard": "Descartar",
	"dialog.dontshowagain": "No volver a mostrar",
	"data.cube": "Cubo",
	"data.group": "Grupo",
	"data.texture": "Textura",
	"data.plugin": "Plugin",
	"data.preview": "Vista previa",
	"data.toolbar": "Barra de herramientas",
	"data.image": "Imagen",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "CMD",
	"keys.delete": "Eliminar",
	"keys.space": "Espacio",
	"keys.leftclick": "Clic izquierdo",
	"keys.middleclick": "Clic central",
	"keys.rightclick": "Clic derecho",
	"keys.tab": "Tabulador",
	"keys.backspace": "Retroceso",
	"keys.enter": "Entrar",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Teclado numérico %0",
	"keys.caps": "Bloq Mayús",
	"keys.menu": "Menú Contextual",
	"keys.left": "Izquierda",
	"keys.up": "Arriba",
	"keys.right": "Derecha",
	"keys.down": "Abajo",
	"keys.pageup": "Página arriba",
	"keys.pagedown": "Página abajo",
	"keys.plus": "Más",
	"keys.comma": "Coma",
	"keys.point": "Punto",
	"keys.minus": "Minúscula",
	"keys.cross": "Cruz",
	"keys.end": "Fin",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Impr. Pantalla",
	"keys.pause": "Pausa",
	"message.rotation_limit.title": "Límites de rotación",
	"message.rotation_limit.message": "Las rotaciones están limitadas por Minecraft en un sólo eje y en incrementos de 22.5 grados. Rotar en un eje diferente quitará la rotación en otros ejes. Convierte el modelo a \"Modelo Libre\" si quieres modelar para otros propósitos y necesitas rotaciones libres.",
	"message.file_not_found.title": "Archivo No Encontrado",
	"message.file_not_found.message": "Blockbench no pudo encontrar el archivo pedido. Asegúrate de que está guardado localmente y no en una nube.",
	"message.screenshot.title": "Captura de pantalla",
	"message.screenshot.clipboard": "Portapapeles",
	"message.screenshot.right_click": "Clic derecho o mantén presionado para copiar la captura de pantalla",
	"message.invalid_file.title": "Archivo no válido",
	"message.invalid_file.message": "No se pudo abrir el archivo del modelo: %0",
	"message.invalid_model.title": "Archivo de Modelo Inválido",
	"message.invalid_model.message": "Este archivo no contiene información de modelo válida.",
	"message.child_model_only.title": "Modelo Hijo Vacío",
	"message.child_model_only.message": "Este archivo es hijo de %0 y no contiene ningún modelo.",
	"message.unsaved_textures.title": "Texturas sin guardar",
	"message.unsaved_textures.message": "Tu modelo tiene texturas sin guardar. Asegúrate de guardarlas en la carpeta correcta del paquete de recursos.",
	"message.model_clipping.title": "Módelo Muy Grande",
	"message.model_clipping.message": "Tu modelo contiene %0 cubos que son más grandes que el límite de bloques permitido por Minecraft. Este modelo no funcionará en Minecraft.",
	"message.loose_texture.title": "Importar Textura",
	"message.loose_texture.message": "La texture importada no forma parte de un Resource Pack. Minecraft sólo puede cargar texturas dentro de una carpeta de textures en un Resource Pack cargado.",
	"message.loose_texture.change": "Cambiar Ruta",
	"message.update_res.title": "Resolución de Textura",
	"message.update_res.message": "¿Quieres actualizar la resolución del proyecto a la resolución de esta textura? Dale clic a \"Cancelar\" si la textura tiene una resolución mayor a la normal.",
	"message.update_res.update": "Actualizar",
	"message.bedrock_overwrite_error.message": "Blockbench no puede combinar este modelo con un archivo viejo",
	"message.bedrock_overwrite_error.backup_overwrite": "Crear copia de seguridad y sobrescribir",
	"message.bedrock_overwrite_error.overwrite": "Sobrescribir",
	"message.close_warning.message": "¿Quiéres guardar tu modelo?",
	"message.close_warning.web": "Tu trabajo actual se perderá. ¿Estás seguro de que quieres salir?",
	"message.default_textures.title": "Texturas por defecto",
	"message.default_textures.message": "Selecciona la carpeta \"textures\" del paquete de recursos por defecto",
	"message.default_textures.detail": "Extrae el paquete de texturas por defecto del Minecraft jar o búscalo en Google y descárgalo. Después busca la carpeta \"textures\" y ábrela. Blockbench recordará esa localización y tratará de extraer las texturas desde ahí si no las puede encontrar en el paquete de texturas actual.",
	"message.default_textures.select": "Selecciona la carpeta \"textures\" por defecto",
	"message.image_editor.title": "Selecciona un editor de imágenes",
	"message.image_editor.file": "Seleccionar Archivo...",
	"message.image_editor.exe": "Seleccionar el ejecutable de un editor de imágenes",
	"message.display_skin.title": "Skin de Minecraft",
	"message.display_skin.message": "Selecciona un archivo de una skin de tu computadora o escribe el nombre de un jugador",
	"message.display_skin.upload": "Seleccionar Archivo",
	"message.display_skin.reset": "Restablecer",
	"message.invalid_plugin": "Archivo de plugin inválido, lee la Consola",
	"message.load_plugin_app": "¿Quieres permitir a este plugin que haga cambios a tu PC? Carga sólo plugins de personas en las que confíes.",
	"message.load_plugin_web": "¿Quieres cargar este plugin? Carga sólo plugins de personas en las que confíes.",
	"message.preset_no_info": "La plantilla no contiene información para este apartado",
	"message.restart_to_update": "Reinicie Blockbench para aplicar cambios",
	"message.save_file": "Guardado como %0",
	"dialog.project.title": "Proyecto",
	"dialog.project.name": "Nombre de Archivo",
	"dialog.project.parent": "Modelo Padre",
	"dialog.project.geoname": "Identificador del Modelo",
	"dialog.project.ao": "Oclusión Ambiental",
	"dialog.texture.title": "Textura",
	"dialog.texture.variable": "Variable",
	"dialog.texture.namespace": "Espacio del Nombre",
	"dialog.texture.folder": "Carpeta",
	"dialog.extrude.title": "Extruir imagen",
	"dialog.extrude.mode": "Modo de Escaneo",
	"dialog.extrude.mode.areas": "Areas",
	"dialog.extrude.mode.lines": "Líneas",
	"dialog.extrude.mode.columns": "Columnas",
	"dialog.extrude.mode.pixels": "Píxeles",
	"dialog.extrude.opacity": "Opacidad Mínima",
	"dialog.extrude.scan": "Escanear e Importar",
	"dialog.display_preset.title": "Crear Plantilla",
	"dialog.display_preset.message": "Selecciona los apartados que quieras guardar",
	"dialog.display_preset.create": "Crear",
	"dialog.select.title": "Seleccionar",
	"dialog.select.group": "En el Grupo Seleccionado",
	"dialog.select.name": "El Nombre Contiene",
	"dialog.select.random": "Probabilidad Aleatoria (%)",
	"dialog.select.select": "Seleccionar",
	"dialog.scale.title": "Reescalar Modelo",
	"dialog.scale.axis": "Ejes",
	"dialog.scale.clipping": "El modelo sobresale: Es demasiado grande para el espacio de trabajo",
	"dialog.scale.confirm": "Reescalar",
	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Instalado",
	"dialog.plugins.available": "Disponible",
	"dialog.plugins.install": "Instalar",
	"dialog.plugins.uninstall": "Desinstalar",
	"dialog.plugins.reload": "Recargar",
	"dialog.plugins.none_installed": "No hay plugins instalados",
	"dialog.plugins.none_available": "No hay plugins disponibles",
	"dialog.plugins.web_only": "Sólo para la página web",
	"dialog.plugins.app_only": "Sólo para el programa de escritorio",
	"dialog.plugins.author": "por %0",
	"dialog.create_texture.folder": "Carpeta",
	"dialog.create_texture.resolution": "Resolución",
	"dialog.input.title": "Entrada",
	"dialog.settings.settings": "Ajustes",
	"dialog.settings.keybinds": "Atajos de Teclado",
	"dialog.settings.about": "Acerca de",
	"layout.color.back": "Fondo",
	"layout.color.back.desc": "Fondos y cajas de entrada",
	"layout.color.dark": "Oscuro",
	"layout.color.dark.desc": "Fondo del espacio de trabajo",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "Color principal de la interfaz",
	"layout.color.bright_ui": "UI Brillante",
	"layout.color.bright_ui.desc": "Menús contextuales e información de herramientas",
	"layout.color.button": "Botón",
	"layout.color.button.desc": "Botones e interruptores",
	"layout.color.selected": "Seleccionado",
	"layout.color.selected.desc": "Pestañas y objectos seleccionados",
	"layout.color.border": "Borde",
	"layout.color.border.desc": "Borde de botones y cajas de entrada",
	"layout.color.accent": "Acento",
	"layout.color.accent.desc": "Deslizador y otros detalles",
	"layout.color.grid": "Cuadrícula",
	"layout.color.grid.desc": "Cuadrícula de vista previa 3D",
	"layout.color.text": "Texto",
	"layout.color.text.desc": "Texto normal",
	"layout.color.light": "Claro",
	"layout.color.light.desc": "Texto resaltado",
	"layout.color.accent_text": "Acento del texto",
	"layout.color.accent_text.desc": "Texto sobre fondos con acento",
	"layout.font.main": "Fuente Principal",
	"layout.font.headline": "Fuente de Títulos",
	"about.version": "Versión:",
	"settings.category.general": "General",
	"settings.category.preview": "Vista Previa",
	"settings.category.grid": "Cuadrícula",
	"settings.category.edit": "Editar",
	"settings.category.snapping": "Imán",
	"settings.category.defaults": "Por defecto",
	"settings.category.dialogs": "Diálogos",
	"settings.category.export": "Exportar",
	"settings.language": "Lenguaje",
	"settings.language.desc": "Lenguaje de Interfaz",
	"settings.backup_interval": "Intervalo de Respaldos",
	"settings.backup_interval.desc": "Intervalo de los respaldos automáticos en minutos",
	"settings.origin_size": "Marcador de Pivote",
	"settings.origin_size.desc": "Tamaño del marcador del punto de pivote",
	"settings.control_size": "Transformar el Tamaño del Artilugio",
	"settings.control_size.desc": "Tamaño de Transformación del Artilugio",
	"settings.display_skin": "Skin de Minecraft",
	"settings.display_skin.desc": "Skin usada para la referencia del modelo jugador",
	"settings.shading": "Sombreado",
	"settings.shading.desc": "Habilitar sombreado en vista previa",
	"settings.base_grid": "Cuadrícula Pequeña",
	"settings.base_grid.desc": "Mostrar cuadrícula y ejes pequeños",
	"settings.large_grid": "Cuadrícula de Bloques",
	"settings.large_grid.desc": "Mostrar cuadrícula de 16x16 bloques",
	"settings.full_grid": "Cuadrícula de Bloques Precisa",
	"settings.full_grid.desc": "Mostrar cuadrícula de bloques con precisión de píxeles",
	"settings.large_box": "Caja con Límite de Tamaño",
	"settings.large_box.desc": "Mostrar límites de tamaño",
	"settings.display_grid": "Modo de Visualización Cuadrícula",
	"settings.display_grid.desc": "Mostrar cuadrícula en el modo de visualización",
	"settings.undo_limit": "Límite de Deshacer",
	"settings.undo_limit.desc": "Número de acciones que puedes deshacer",
	"settings.local_move": "Mover en Ejes Relativos",
	"settings.local_move.desc": "Mover elementos rotados en sus propios ejes si es posible",
	"settings.canvas_unselect": "Deselección con Click en el Espacio de Trabajo",
	"settings.canvas_unselect.desc": "Deseleccionar todos los elementos cuando se hace click en el fondo del espacio de trabajo",
	"settings.paint_side_restrict": "Restringir el Pincel a un Lado",
	"settings.paint_side_restrict.desc": "Restringe los pinceles para que solo pinten en el lado actual",
	"settings.autouv": "Auto UV",
	"settings.autouv.desc": "Activar Auto UV por defecto",
	"settings.create_rename": "Renombrar Nuevo Elemento",
	"settings.create_rename.desc": "Enfocar el campo de nombre al crear un nuevo elemento o grupo",
	"settings.edit_size": "Resolución de Cuadrícula",
	"settings.edit_size.desc": "Resolución de la cuadrícula a la que se ajustan los elementos",
	"settings.shift_size": "Resolución Shift",
	"settings.shift_size.desc": "Resolución de la cuadrícula al mantener Shift",
	"settings.ctrl_size": "Resolución de Control",
	"settings.ctrl_size.desc": "Resolución de la cuadrícula al mantener Control",
	"settings.negative_size": "Tamaño Negativo",
	"settings.negative_size.desc": "Permitir a la herramienta de reescalado usar tamaños negativos",
	"settings.minifiedout": "Exportación Minificada",
	"settings.minifiedout.desc": "Escribir archivos JSON en una línea",
	"settings.export_groups": "Exportar grupos en modelos de bloques/objetos de Java",
	"settings.export_groups.desc": "Guardar grupos en archivos JSON de bloques java o modelos de objeto",
	"settings.credit": "Comentario de Créditos",
	"settings.credit.desc": "Añadir un comentario de créditos a archivos exportados",
	"settings.default_path": "Ruta de Texturas Por Defecto de Minecraft",
	"settings.default_path.desc": "Carpeta desde donde Blockbench carga las texturas por defecto",
	"settings.image_editor": "Editor de Imágenes",
	"settings.image_editor.desc": "Editor de imágenes por defecto con el que editar las texturas",
	"category.navigate": "Navegación",
	"category.tools": "Herramientas",
	"category.file": "Archivo",
	"category.blockbench": "Blockbench",
	"category.edit": "Editar",
	"category.transform": "Transformar",
	"category.view": "Ver",
	"category.display": "Ajustes de Visualización",
	"category.textures": "Texturas",
	"category.misc": "Misceláneo",
	"keybind.preview_select": "Seleccionar",
	"keybind.preview_rotate": "Vista de Rotación",
	"keybind.preview_drag": "Vista de Arrastre",
	"keybind.confirm": "Confirmar",
	"keybind.cancel": "Cancelar",
	"action.slider_inflate": "Inflar",
	"action.slider_inflate.desc": "Inflar cubos en todas las direcciones sin cambiar el UV",
	"action.slider_brush_size": "Tamaño",
	"action.slider_brush_size.desc": "Radio del pincel en píxeles",
	"action.slider_brush_opacity": "Opacidad",
	"action.slider_brush_opacity.desc": "Opacidad del pincel de 0 a 255",
	"action.slider_brush_softness": "Suavidad",
	"action.slider_brush_softness.desc": "Suavidad del pincel en porcentaje",
	"action.uv_slider_pos_x": "Mover Horizontal",
	"action.uv_slider_pos_x.desc": "Mover horizontalmente todas las caras UV seleccionadas",
	"action.uv_slider_pos_y": "Mover Vertical",
	"action.uv_slider_pos_y.desc": "Mover verticalmente todas las caras UV seleccionadas",
	"action.uv_slider_size_x": "Tamaño Horizontal",
	"action.uv_slider_size_x.desc": "Redimensionar horizontalmente todas las caras UV seleccionadas",
	"action.uv_slider_size_y": "Tamaño Vertical",
	"action.uv_slider_size_y.desc": "Redimensionar verticalmente todas las caras UV seleccionadas",
	"action.vertex_snap_mode": "Modo Imán",
	"action.vertex_snap_mode.desc": "Seleccionar si el Imán para Vertices mueve los elementos a la posición seleccionada o si los re-escala",
	"action.move_tool": "Mover",
	"action.move_tool.desc": "Herramienta para seleccionar y mover elementos",
	"action.resize_tool": "Re-escalar",
	"action.resize_tool.desc": "Herramienta para seleccionar y re-escalar elementos",
	"action.brush_tool": "Pincel de pintura",
	"action.brush_tool.desc": "Pincel de color para dibujar sobre texturas",
	"action.vertex_snap_tool": "Imán para Vértices",
	"action.vertex_snap_tool.desc": "Mover un cubo a otro cubo al conectar 2 vértices",
	"action.swap_tools": "Cambiar Herramientas",
	"action.swap_tools.desc": "Cambiar entre la herramienta para mover y para re-escalar",
	"action.project_window": "Proyecto...",
	"action.project_window.desc": "Abre la ventana del proyecto, donde puedes cambiar la metadata de tu modelo",
	"action.open_model": "Abrir Modelo",
	"action.open_model.desc": "Abre un archivo de modelo de tu computadora",
	"action.extrude_texture": "Textura Extruida",
	"action.extrude_texture.desc": "General un modelo al extender una textura",
	"action.export_blockmodel": "Exportar modelo de bloque/objeto",
	"action.export_blockmodel.desc": "Exportar un modelo de bloque o de objeto de Minecraft Java Edition",
	"action.export_optifine_part": "Exportar Parte de Optifine",
	"action.export_optifine_part.desc": "Exportar una sola parte para un modelo de entidad de OptiFine",
	"action.export_optifine_full": "Exportar a OptiFine JEM",
	"action.export_optifine_full.desc": "Exportar un modelo completo de entidad de OptiFine",
	"action.export_obj": "Exportar Modelo OBJ",
	"action.export_obj.desc": "Exportar un modelo Wavefront OBJ para su renderización",
	"action.settings_window": "Ajustes...",
	"action.settings_window.desc": "Abre la ventana de ajustes de Blockbench.",
	"action.plugins_window": "Plugins...",
	"action.plugins_window.desc": "Abre la ventana de la tienda de plugins",
	"action.reset_layout": "Resetear Diseño",
	"action.reset_layout.desc": "Resetea el diseño al que tiene Blockbench por defecto",
	"action.load_plugin": "Cargar Plugin desde Archivo",
	"action.load_plugin.desc": "Carga un plugin importando el archivo base",
	"action.reload_plugins": "Recargar Plugins",
	"action.reload_plugins.desc": "Recarga todos los plugins en desarrollo",
	"action.undo": "Deshacer",
	"action.undo.desc": "Deshace el último cambio",
	"action.redo": "Rehacer",
	"action.redo.desc": "Rehace el último cambio",
	"action.copy": "Copiar",
	"action.copy.desc": "Copia la selección, cara o ajustes de visualización",
	"action.paste": "Pegar",
	"action.paste.desc": "Pega la selección, cara o ajustes de visualización",
	"action.cut": "Cortar",
	"action.cut.desc": "Corta la selección, cara o ajustes de visualización",
	"action.add_cube": "Añadir Cubo",
	"action.add_cube.desc": "Añade un nuevo cubo",
	"action.add_group": "Añadir Grupo",
	"action.add_group.desc": "Añade un nuevo grupo o hueso",
	"action.outliner_toggle": "Activar Más Opciones",
	"action.outliner_toggle.desc": "Cambia los botones para más opciones en el Esquema",
	"action.duplicate": "Duplicar",
	"action.delete": "Borrar",
	"action.sort_outliner": "Ordenar Esquema",
	"action.sort_outliner.desc": "Ordena el esquema alfabéticamente",
	"action.select_window": "Seleccionar...",
	"action.select_window.desc": "Busca y seleccionar elementos basados en sus propiedades",
	"action.invert_selection": "Invertir Selección",
	"action.invert_selection.desc": "Invertir la selección actual de elementos",
	"action.select_all": "Seleccionar Todo",
	"action.collapse_groups": "Contraer Grupos",
	"action.collapse_groups.desc": "Contraer todos los grupos del esquema",
	"action.scale": "Re-escalar...",
	"action.scale.desc": "Escalar los elementos seleccionados",
	"action.toggle_visibility": "Cambiar Visibilidad",
	"action.toggle_visibility.desc": "Cambiar la visibilidad de los elementos seleccionados",
	"action.toggle_export": "Cambiar Exportación",
	"action.toggle_export.desc": "Cambia el ajuste de exportación de los elementos seleccionados",
	"action.toggle_autouv": "Cambiar Auto UV",
	"action.toggle_autouv.desc": "Cambia el ajuste de Auto UV de los elementos seleccionados",
	"action.toggle_shade": "Cambiar Sombreado",
	"action.toggle_shade.desc": "Cambia el ajuste de sombreado de los elementos seleccionados",
	"action.rename": "Renombrar",
	"action.rename.desc": "Cambia el nombre de los elementos seleccionados",
	"action.add_display_preset": "Nueva Plantilla",
	"action.add_display_preset.desc": "Añade un nuevo pre-ajuste de visualización",
	"action.fullscreen": "Pantalla Completa",
	"action.fullscreen.desc": "Cambia al modo de pantalla completa",
	"action.zoom_in": "Hacer zoom",
	"action.zoom_in.desc": "Hace zoom para hacer la interfaz más grande",
	"action.zoom_out": "Quitar zoom",
	"action.zoom_out.desc": "Quita zoom para hacer la interfaz más pequeña",
	"action.zoom_reset": "Resetear Zoom",
	"action.zoom_reset.desc": "Resetea el zoom al 100% por defecto",
	"action.reset_interface": "Resetar Interfaz",
	"action.reset_interface.desc": "Resetea el tamaño y las posiciones de la Interfaz",
	"action.screenshot_model": "Captura de Pantalla del Modelo",
	"action.screenshot_model.desc": "Toma una captura de pantalla recortada del modelo desde el ángulo actual",
	"action.screenshot_app": "Captura de Pantalla de la Aplicación",
	"action.screenshot_app.desc": "Toma una captura de pantalla de toda la aplicación",
	"action.import_texture": "Importar Textura",
	"action.import_texture.desc": "Importa una o más texturas de tu sistema de archivos",
	"action.create_texture": "Crear Textura",
	"action.create_texture.desc": "Crea una textura en blanco o para una plantilla",
	"action.save_textures": "Guardar Texturas",
	"action.save_textures.desc": "Guarda todas las texturas que no han sido guardadas",
	"action.animated_textures": "Activar Texturas Animadas",
	"action.animated_textures.desc": "Reproducir y pausar la vista previa de texturas animadas",
	"action.origin_to_geometry": "Centrar Pivote",
	"action.origin_to_geometry.desc": "Pone el punto de pivote al centro de la selección",
	"action.bone_reset_toggle": "Resetear Hueso",
	"action.bone_reset_toggle.desc": "Impide que el hueso muestre cubos del modelo padre",
	"action.reload": "Recargar Blockbench",
	"action.reload.desc": "Recarga Blockbench. Esto borrará todo el progreso no guardado",
	"menu.file": "Archivo",
	"menu.edit": "Editar",
	"menu.transform": "Transformar",
	"menu.display": "Visualización",
	"menu.view": "Ver",
	"menu.file.new": "Nuevo",
	"menu.file.recent": "Reciente",
	"menu.file.import": "Importar",
	"menu.file.export": "Exportar",
	"menu.transform.rotate": "Rotar",
	"menu.transform.flip": "Invertir",
	"menu.transform.center": "Centrar",
	"menu.transform.properties": "Propiedades",
	"menu.display.preset": "Aplicar Plantilla",
	"menu.display.preset_all": "Aplicar Plantilla en Todo",
	"menu.display.remove_preset": "Borrar Plantilla",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Fondo",
	"menu.view.screenshot": "Captura de Pantalla",
	"menu.cube.color": "Color",
	"menu.cube.texture": "Textura",
	"menu.cube.texture.transparent": "Transparente",
	"menu.cube.texture.blank": "En Blanco",
	"menu.group.sort": "Ordenar",
	"menu.texture.face": "Aplicar a Cara",
	"menu.texture.file": "Archivo",
	"menu.texture.refresh": "Refrescar",
	"menu.texture.change": "Cambiar Archivo",
	"menu.texture.folder": "Mostrar en el Explorador de archivos",
	"menu.texture.edit": "Editar",
	"menu.texture.export": "Guardar Como",
	"menu.texture.save": "Guardar",
	"menu.texture.properties": "Propiedades...",
	"menu.preview.background": "Fondo",
	"menu.preview.background.load": "Cargar",
	"menu.preview.background.position": "Posición",
	"menu.preview.background.lock": "Fijar a la Cámara",
	"menu.preview.screenshot": "Captura de Pantalla",
	"menu.preview.perspective": "Perspectiva",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Vista Cuádruple",
	"menu.preview.stop_drag": "Parar la Colocación del Fondo",
	"menu.uv.mapping.rotation": "Rotación",
	"menu.uv.texture": "Textura",
	"cube.color.light_blue": "Azul claro",
	"cube.color.yellow": "Amarillo",
	"cube.color.orange": "Naranja",
	"cube.color.red": "Rojo",
	"cube.color.purple": "Morado",
	"cube.color.blue": "Azul",
	"cube.color.green": "Verde",
	"cube.color.lime": "Lima",
	"switches.visibility": "Visibilidad",
	"switches.export": "Exportar",
	"switches.autouv": "Auto UV",
	"panel.uv": "UV",
	"panel.display": "Visualización",
	"panel.textures": "Texturas",
	"panel.outliner": "Esquema",
	"uv_editor.title": "Editor de UV",
	"uv_editor.all_faces": "Todo",
	"uv_editor.no_faces": "Ninguno",
	"face.north": "Norte",
	"face.south": "Sur",
	"face.west": "Oeste",
	"face.east": "Este",
	"face.up": "Arriba",
	"face.down": "Abajo",
	"direction.north": "Norte",
	"direction.south": "Sur",
	"direction.west": "Oeste",
	"direction.east": "Este",
	"direction.top": "Arriba",
	"direction.bottom": "Abajo",
	"display.slot.third_right": "Tercera Persona, Derecha",
	"display.slot.third_left": "Tercera Persona, Izquierda",
	"display.slot.first_right": "Primera Persona, Derecha",
	"display.slot.first_left": "Primera Persona, Izquierda",
	"display.slot.head": "Cabeza",
	"display.slot.ground": "Suelo",
	"display.slot.frame": "Marco",
	"display.slot.gui": "Interfaz",
	"display.rotation": "Rotación",
	"display.translation": "Translación",
	"display.scale": "Reescalado",
	"display.slot": "Apartado",
	"display.reference": "Modelo de Referencia",
	"display.reference.player": "Jugador",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Armor Stand",
	"display.reference.baby_zombie": "Zombie bebé",
	"display.reference.armor_stand_small": "Armor Stand Pequeño",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Arco Cargado",
	"display.reference.block": "Bloque",
	"display.reference.frame": "Marco de Objetos",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventario",
	"display.reference.hud": "Interfaz",
	"display.preset.blank_name": "Por favor, introduce un nombre",
	"display.preset.item": "Objeto Por Defecto",
	"display.preset.block": "Bloque por defecto",
	"display.preset.handheld": "Arma por defecto",
	"display.preset.rod": "Palo por defecto",
	"dialog.continue": "Continuar",
	"message.square_textures": "Las texturas tienen que ser cuadradas",
	"message.unsaved_texture.title": "Textura sin guardar",
	"message.unsaved_texture.message": "Todos los cambios no guardados de esta textura serán perdidos. ¿Quieres continuar?",
	"action.vertex_snap_mode.move": "Mover",
	"action.vertex_snap_mode.scale": "Reescalar",
	"action.open_model_folder": "Abrir la Carpeta del Modelo",
	"action.open_model_folder.desc": "Abre la carpeta que contiene al modelo dentro",
	"action.change_textures_folder": "Cambiar Localización de las Texturas",
	"action.change_textures_folder.desc": "Cambia la carpeta que en la que se guardan todas las texturas",
	"menu.texture.particle": "Usar para Partículas",
	"message.update_notification.title": "No fue posible Instalar la Actualización",
	"message.update_notification.message": "Una nueva versión de Blockbench está disponible. Por favor, active las Actualizaciones Automáticas en la configuración para actualizar!",
	"message.untextured": "La superficie no tiene una textura",
	"dialog.toolbar_edit.title": "Personalizar Barra de Herramientas",
	"keybindings.reset": "Resetear",
	"keybindings.clear": "Vacío",
	"action.cube_counter": "Estadísticas del Modelo",
	"action.uv_rotation": "Rotación del UV",
	"action.uv_rotation.desc": "Rotación de la cara del UV",
	"action.uv_grid": "Cuadrícula del UV",
	"action.uv_grid.desc": "La resolución de la cuadrícula a la que el selector del UV se engancha",
	"action.uv_grid.auto": "Automático",
	"action.uv_maximize": "Maximizar UV",
	"action.uv_maximize.desc": "Configura el UV para esta cara a la textura completa",
	"action.uv_auto": "Auto UV",
	"action.uv_auto.desc": "Configura el tamaño del UV de esta cara al tamaño real de la propia cara",
	"action.uv_rel_auto": "Auto UV Relativo",
	"action.uv_rel_auto.desc": "Configura el UV de esta cara a la posición y tamaño de la propia cara",
	"action.uv_mirror_x": "Invertir UV en X",
	"action.uv_mirror_x.desc": "Invierte el UV de esta cara en el eje X",
	"action.uv_mirror_y": "Invertir UV en Y",
	"action.uv_mirror_y.desc": "Invierte el UV de esta cara en el eje Y",
	"action.uv_transparent": "Eliminar Cara",
	"action.uv_transparent.desc": "Convierte la cara actual en transparente",
	"action.uv_reset": "Resetear Cara",
	"action.uv_reset.desc": "Resetea la cara actual",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Deshabilita el renderizado para esta cara si el lado seleccionado del modelo está cubierto",
	"action.auto_cullface": "Auto Cullface",
	"action.auto_cullface.desc": "Configura el cullface para esta cara a sí mismo",
	"action.face_tint": "Tintar",
	"action.face_tint.desc": "Habilita la opción de tintado para la cara actual",
	"menu.toolbar.edit": "Personalizar Barra de Herramientas",
	"menu.toolbar.reset": "Resetear",
	"uv_editor.rotated": "Rotado",
	"uv_editor.auto_cull": "Cullface a sí Mismo",
	"uv_editor.copied": "Cara Copiada",
	"uv_editor.pasted": "Cara Pegada",
	"uv_editor.copied_x": "Copiadas %0 Caras",
	"uv_editor.reset": "Resetear Cara",
	"uv_editor.maximized": "Maximizada",
	"uv_editor.autouv": "Tamaño Automático",
	"uv_editor.mirrored": "Invertida",
	"uv_editor.to_all": "Aplicar a Todas Las Caras",
	"uv_editor.transparent": "Hecho transparente",
	"uv_editor.cullface_on": "Cullface Activado",
	"uv_editor.cullface_off": "Cullface Desactivado",
	"uv_editor.tint_on": "Tintar Activado",
	"uv_editor.tint_off": "Tintar Desactivado",
	"action.uv_apply_all": "Aplicar a Todas las Caras",
	"action.uv_apply_all.desc": "Aplica los ajustes de la cara actual a todas las caras",
	"message.image_editor_missing.title": "Editor de Imágenes por Defecto",
	"message.image_editor_missing.message": "Selecciona el archivo ejecutable de tu editor de imágenes.",
	"message.image_editor_missing.detail": "Blockbench no pudo encontrar un editor de imágenes en tu computadora. Selecciona el archivo ejecutable de tu editor de imágenes preferido.",
	"action.update_autouv": "Actualizar Auto UV",
	"action.update_autouv.desc": "Actualiza el mapeado del auto UV en los cubos seleccionados",
	"category.uv": "UV",
	"status_bar.saved": "El modelo está guardado",
	"status_bar.unsaved": "Hay cambios sin guardar",
	"action.move_up": "Mover Hacia Arriba",
	"action.move_up.desc": "Mueve los cubos seleccionados hacia arriba relativo al ángulo actual de la cámara",
	"action.move_down": "Mover Hacia Abajo",
	"action.move_down.desc": "Mueve los cubos seleccionados hacia abajorelativo al ángulo actual de la cámara",
	"action.move_left": "Mover Hacia Izquierda",
	"action.move_left.desc": "Mueve los cubos seleccionados hacia la izquierda relativo al ángulo actual de la cámara",
	"action.move_right": "Mover Hacia Derecha",
	"action.move_right.desc": "Mueve los cubos seleccionados hacia la derecha relativo al ángulo actual de la cámara",
	"action.move_forth": "Mover Hacia Delante",
	"action.move_forth.desc": "Mueva los elementos seleccionados hacia adelante en relación con el ángulo actual de la cámara",
	"action.move_back": "Mover Hacia Atrás",
	"action.move_back.desc": "Mueve los cubos seleccionados hacia atrás relativo al ángulo actual de la cámara",
	"layout.color.wireframe": "Estructura",
	"layout.color.wireframe.desc": "Líneas de vista de la estructura",
	"layout.color.wireframe_selectable": "Estructura seleccionable",
	"layout.color.wireframe_selectable.desc": "Aristas y vértices no seleccionados de la malla activa en modo edición",
	"action.add_animation": "Añadir Animación",
	"action.add_animation.desc": "Crear Animación Vacía",
	"action.load_animation_file": "Importar Animaciones",
	"action.load_animation_file.desc": "Importa un archivo de animación",
	"action.play_animation": "Mostrar Animaciones",
	"action.play_animation.desc": "Previsualiza la animación seleccionada",
	"action.slider_keyframe_time": "Código de tiempo",
	"action.slider_keyframe_time.desc": "Cambia el código de tiempo de los frames clave seleccionados",
	"timeline.rotation": "Rotación",
	"timeline.position": "Posición",
	"timeline.scale": "Escala",
	"menu.keyframe.quaternion": "Quaternion",
	"panel.animations": "Animaciones",
	"panel.keyframe": "Fotograma Clave",
	"panel.keyframe.type": "Fotograma Clave (%0)",
	"generic.delete": "Eliminar",
	"generic.rename": "Renombrar",
	"message.no_animation_selected": "Tienes que seleccionar una animación para hacer esto",
	"message.no_bone_selected": "Tienes que seleccionar un hueso para hacer esto",
	"message.duplicate_groups.title": "Duplicar Nombre del Hueso",
	"message.duplicate_groups.message": "El nombre de este hueso existe en varios huesos. Esto puede causar problemas",
	"action.delete_keyframes": "Eliminar Fotogramas Clave",
	"action.delete_keyframes.desc": "Elimina todos los fotogramas clave seleccionados",
	"menu.animation": "Animación",
	"menu.animation.loop": "Modo de bucle",
	"menu.animation.override": "Sobreescribir",
	"menu.animation.anim_time_update": "Actualizar Variable",
	"message.display_skin_model.title": "Modelo de Skin",
	"message.display_skin_model.message": "Escoge el tipo de modelo de tu skin",
	"message.display_skin_model.classic": "Clásico",
	"message.display_skin_model.slim": "Delgado",
	"message.bone_material": "Cambiar el material del hueso",
	"action.slider_animation_length": "Duración de la Animación",
	"action.slider_animation_length.desc": "Cambia la duración de la animación seleccionada",
	"panel.variable_placeholders": "Variables Temporales",
	"panel.variable_placeholders.info": "Muestra las variables que quieres visualizar mediante nombre=valor",
	"status_bar.vertex_distance": "Distancia: %0",
	"dialog.create_gif.title": "Grabar GIF",
	"dialog.create_gif.length": "Duración",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Reproducir Animación",
	"category.animation": "Animación",
	"action.record_model_gif": "Grabar GIF...",
	"action.record_model_gif.desc": "Graba un GIF animado de este modelo desde este ángulo",
	"display.mirror": "Invertir",
	"data.separator": "Separador",
	"menu.preview.background.set_position": "Ajustar Posición",
	"dialog.toolbar_edit.hidden": "Oculto",
	"action.export_class_entity": "Exportar Entidad de Java",
	"action.export_class_entity.desc": "Exporta el modelo de entidad como una clase de Java",
	"settings.seethrough_outline": "Bordes Rayos-X",
	"settings.seethrough_outline.desc": "Mostrar los bordes a través de los objetos",
	"mode.edit": "Editar",
	"mode.paint": "Pintar",
	"mode.display": "Mostrar",
	"mode.animate": "Animar",
	"status_bar.recording_gif": "Grabando",
	"status_bar.processing_gif": "Procesando",
	"settings.backup_retain": "Mantenimiento de Respaldos",
	"settings.backup_retain.desc": "Ajustar cuanto tiempo Blockbench mantiene respaldos viejos en días",
	"action.rotate_tool": "Rotar",
	"action.rotate_tool.desc": "Herramienta para seleccionar y rotar elementos",
	"action.fill_tool": "Cubo de Pintura",
	"action.fill_tool.desc": "Herramienta para rellenar caras enteras con un color",
	"action.eraser": "Borrador",
	"action.eraser.desc": "Herramienta para reemplazar colores en una textura por transparencia",
	"action.color_picker": "Selector de Color",
	"action.color_picker.desc": "Herramienta para seleccionar el color de píxeles en tu textura",
	"switches.mirror": "Invertir UV",
	"language_name": "Español",
	"message.plugin_reload": "Recargados %0 plugins locales",
	"settings.brightness": "Brillo",
	"settings.brightness.desc": "Brillo de la vista previa. Por defecto es 50",
	"menu.preview.perspective.reset": "Resetear Cámara",
	"action.fill_mode": "Modo de Llenado",
	"action.fill_mode.face": "Cara",
	"action.fill_mode.color": "Colores",
	"action.toggle_mirror_uv": "Invertir UV",
	"action.toggle_mirror_uv.desc": "Activa el invertido de UV en el eje X de los cubos seleccionados",
	"menu.texture.blank": "Aplicar a Caras sin Textura",
	"dialog.scale.select_overflow": "Seleccionar Overflow",
	"action.action_control": "Control de Acción",
	"action.action_control.desc": "Busca y ejecuta cualquier acción disponible",
	"keybindings.recording": "Anotando Atajo de Teclado",
	"keybindings.press": "Pulsa una tecla o una combinación de teclas o haz click en cualquier lugar de tu pantalla para anotar el atajo de teclado",
	"action.pivot_tool": "Herramienta de Pivote",
	"action.pivot_tool.desc": "Herramienta para cambiar el punto de pivote de cubos y huesos",
	"action.slider_animation_speed": "Velocidad de Playback",
	"action.slider_animation_speed.desc": "Velocidad de playback del línea de tiempo en porcentaje",
	"action.previous_keyframe": "Fotograma Clave Anterior",
	"action.previous_keyframe.desc": "Salta al fotograma clave anterior",
	"action.next_keyframe": "Fotograma Clave Siguiente",
	"action.next_keyframe.desc": "Salta al fotograma clave siguiente",
	"message.outdated_client.title": "Programa desactualizado",
	"message.outdated_client.message": "Por favor actualiza a la última versión de Blockbench para hacer esto.",
	"action.export_asset_archive": "Descargar Archivo",
	"action.export_asset_archive.desc": "Descarga un archivo con el modelo y todas las texturas en él",
	"action.upload_sketchfab": "Subir a Sketchfab",
	"message.sketchfab.name_or_token": "Por favor, introduce tu token de Sketchfab y un nombre",
	"dialog.sketchfab_uploader.title": "Subir Modelo de Sketchfab",
	"dialog.sketchfab_uploader.token": "Token de API",
	"dialog.sketchfab_uploader.about_token": "El token es usado para conectar Blockbench a tu cuenta de Sketchfab. Puedes encontrarlo en %0",
	"dialog.sketchfab_uploader.name": "Nombre del Modelo",
	"dialog.sketchfab_uploader.description": "Descripción",
	"dialog.sketchfab_uploader.tags": "Etiquetas",
	"settings.sketchfab_token": "Token de Sketchfab",
	"settings.sketchfab_token.desc": "Token para autorizar a Blockbench a subir a tu cuenta de Sketchfab",
	"panel.color": "Color",
	"data.origin": "Pivote",
	"message.sketchfab.success": "Modelo subido con éxito",
	"message.sketchfab.error": "La subida del modelo a Sketchfab ha fallado",
	"settings.outliner_colors": "Colores del Esquema",
	"settings.outliner_colors.desc": "Mostrar colores de los elementos y grupos en el esquema",
	"action.upload_sketchfab.desc": "Subir tu modelo a Sketchfab",
	"action.element_colors": "Colores de Cubo",
	"action.element_colors.desc": "Mostrar colores de los cubos en el esquema",
	"texture.error.file": "Archivo no encontrado",
	"texture.error.parent": "Archivo de textura proveído por el modelo padre",
	"message.recover_backup.title": "Recuperar Modelos",
	"message.recover_backup.message": "Blockbench fue cerrado sin guardar. ¿Quieres recuperar el modelo?",
	"message.invalid_session.title": "Token de Sesión Inválido",
	"message.invalid_session.message": "La sesión a la que estas intentando entrar ha expirado o el token proveído es inválido.",
	"dialog.create_texture.power": "Tamaño Al Cuadrado",
	"dialog.create_gif.turn": "Velocidad del Tocadiscos",
	"action.edit_session": "Editar Sesión...",
	"action.edit_session.desc": "Conectarse a una sesión de edición para colaborar con otros usuarios",
	"action.reset_keyframe": "Resetear Fotogramas Clave",
	"action.reset_keyframe.desc": "Resetea todos los valores de los fotogramas clave seleccionados",
	"dialog.edit_session.title": "Editar Sesión",
	"edit_session.username": "Nombre de Usuario",
	"edit_session.token": "Token",
	"edit_session.about": "Editar Sesiones puede ser utilizado para colaborar en modelos a través de Internet. Crea una sesión, copia el token y mándaselo a amigos, los cuales lo pueden usar para entrar.",
	"edit_session.join": "Entrar a Sesión",
	"edit_session.create": "Crear Sesión",
	"edit_session.quit": "Salir de Sesión",
	"edit_session.joined": "%0 ha entrado a la sesión",
	"edit_session.left": "%0 ha salido de la sesión",
	"edit_session.quit_session": "Salir de la sesión actual",
	"edit_session.status": "Estado",
	"edit_session.hosting": "Anfitrión",
	"edit_session.connected": "Conectado a una sesión",
	"dialog.sketchfab_uploader.private": "Privado (Pro)",
	"dialog.sketchfab_uploader.password": "Contraseña (Pro)",
	"action.uv_select_all": "Seleccionar Todos",
	"action.uv_select_all.desc": "Selecciona todas las caras en el diálogo del UV",
	"panel.chat": "Chat",
	"edit_session.welcome": "Bienvenido a esta sesión por %0",
	"dialog.yes": "Sí",
	"dialog.no": "No",
	"generic.remove": "Eliminar",
	"generic.download": "Descargar",
	"generic.search": "Buscar",
	"dates.today": "Hoy",
	"dates.yesterday": "Ayer",
	"dates.this_week": "Esta semana",
	"dates.weeks_ago": "Hace %0 semanas",
	"mode.start.new": "Nuevo",
	"mode.start.recent": "Reciente",
	"format.free": "Modelo Genérico",
	"format.free.desc": "Modelo sin restricciones. Para renders, Unity, etc.",
	"format.java_block": "Objeto/Bloque de Java",
	"format.java_block.desc": "Modelo de bloque o objeto para la edición Java.",
	"format.bedrock": "Entidad de Bedrock",
	"format.bedrock.desc": "Modelo de Minecraft Bedrock Edition para entidades y objetos acoplables",
	"format.bedrock_old": "Modelo Antiguo de Bedrock",
	"format.bedrock_old.desc": "Modelo de entidad de las ediciones de Bedrock anteriores a 1.12",
	"format.modded_entity": "Entidad Modificada",
	"format.modded_entity.desc": "Modelo de entidad para mods de Minecraft. Se puede exportar como archivos de clase .java",
	"format.optifine_entity": "Entidad de OptiFine",
	"format.optifine_entity.desc": "Modelo de entidad específico para OptiFine",
	"keys.mouse": "Botón %0 del Ratón",
	"message.cleared_blank_faces.title": "Caras en Blanco",
	"message.cleared_blank_faces.message": "Blockbench ha encontrado %0 cubos sin textura. ¿Quieres eliminar esos elementos?",
	"message.wireframe.enabled": "Visualización de la estructura activada",
	"message.wireframe.disabled": "Visualización de la estructura desactivada",
	"dialog.convert_project.title": "Convertir Proyecto",
	"dialog.create_texture.double_use": "Mantener la Ocupación de Múltiples Texturas",
	"dialog.model_stats.title": "Estadísticas del Modelo",
	"dialog.model_stats.cubes": "Cubos",
	"dialog.model_stats.locators": "Localizadores",
	"dialog.model_stats.groups": "Grupos",
	"dialog.model_stats.vertices": "Vértices",
	"dialog.model_stats.faces": "Caras",
	"settings.username": "Usuario",
	"settings.username.desc": "Usuario para sesiones de edición",
	"settings.painting_grid": "Cuadrícula de Pintura",
	"settings.painting_grid.desc": "Muestra la cuadrícula en cubos texturizados en el modo pintura",
	"action.convert_project": "Convertir Proyecto",
	"action.convert_project.desc": "Convierte el proyecto actual a un proyecto para otro formato de modelo",
	"action.close_project": "Cerrar Proyecto",
	"action.close_project.desc": "Cierra el proyecto abierto actualmente",
	"action.export_bedrock": "Exportar como Geometría de Bedrock",
	"action.export_bedrock.desc": "Exporta el modelo como un archivo de geometría de la edición Bedrock",
	"action.save_project": "Guardar Proyecto",
	"action.save_project.desc": "Guarda el modelo actual como un archivo de proyecto",
	"action.save_project_as": "Guardar Proyecto Como",
	"action.save_project_as.desc": "Guarda el modelo actual como un archivo de proyecto en una nueva localización",
	"action.export_over": "Guardar Modelo",
	"action.export_over.desc": "Guarda el modelo, las texturas y las animaciones al sobreescribir los archivos",
	"action.add_locator": "Añadir Localizador",
	"action.add_locator.desc": "Añade un nuevo localizador para controlar las posiciones de partículas, cadenas, etc...",
	"action.uv_turn_mapping": "Girar Mapeado",
	"action.uv_turn_mapping.desc": "Gira el mapeado del UV 90º",
	"action.remove_blank_faces": "Eliminar Caras en Blanco",
	"action.remove_blank_faces.desc": "Elimina todas las caras sin textura de la selección",
	"web.download_app": "Descargar Aplicación",
	"uv_editor.turned": "Mapeado Girado",
	"display.reference.crossbow": "Ballesta Cargada",
	"dialog.settings.search_results": "Resultados de Búsqueda",
	"settings.animation_snap": "Imán de Animación",
	"settings.animation_snap.desc": "Intervalo del imán para fotogramas clave en la línea de tiempo de la animación en pasos por segundo. Esto puede ser modificado para cada animación. El valor por defecto es 24.",
	"action.import_optifine_part": "Importar Parte de OptiFine",
	"action.import_optifine_part.desc": "Importa un modelo de parte de entidad para OptiFine",
	"data.locator": "Localizador",
	"mode.start.no_recents": "No hay modelos abiertos recientemente",
	"panel.element": "Elemento",
	"panel.element.position": "Posición",
	"panel.element.size": "Tamaño",
	"panel.element.origin": "Punto de Pivote",
	"panel.element.rotation": "Rotación",
	"message.canvas_limit_error.title": "Error de Límite del Lienzo",
	"message.canvas_limit_error.message": "La acción no pudo ser ejecutada correctamente porque el formato limita el lienzo a 48 unidades. Cambia el punto pivote para prevenir esto.",
	"data.effect": "Efecto",
	"generic.name": "Nombre",
	"settings.recent_projects": "Límite de Modelos Recientes",
	"settings.recent_projects.desc": "Número máximo de modelos recientes para recordar",
	"settings.volume": "Volumen",
	"settings.volume.desc": "Control del volumen para efectos de sonido en animaciones",
	"action.clear_timeline": "Limpiar Línea de Tiempo",
	"action.clear_timeline.desc": "Borra todos los huesos no seleccionados en la línea de tiempo",
	"action.select_effect_animator": "Animar Efectos",
	"action.select_effect_animator.desc": "Abre la línea de tiempo para añadir sonidos y efectos de partícula",
	"action.timeline_focus": "Canal",
	"action.timeline_focus.desc": "Selecciona los canales de animación para mostrar en la línea de tiempo",
	"timeline.particle": "Partícula",
	"timeline.sound": "Sonido",
	"timeline.effects": "Efectos",
	"data.format": "Formato",
	"format.optifine_part": "Parte de OptiFine",
	"format.optifine_part.desc": "Parte JPM para modelos de entidad de OptiFine",
	"action.reverse_keyframes": "Invertir Fotogramas Clave",
	"action.reverse_keyframes.desc": "Invierte el orden de los fotogramas clave seleccionados",
	"generic.help": "Ayuda",
	"message.removed_faces": "Eliminadas %0 caras",
	"dialog.sketchfab_uploader.draft": "Borrador",
	"action.slider_pos": "Mover %0",
	"action.slider_pos.desc": "Mover elementos en el eje %0",
	"action.slider_size": "Tamaño %0",
	"action.slider_size.desc": "Redimensionar elementos en el eje %0",
	"action.slider_rotation": "Rotar %0",
	"action.slider_rotation.desc": "Rotar cubos en el eje %0",
	"action.slider_origin": "Pivote %0",
	"action.slider_origin.desc": "Mover pivote en el eje %0",
	"action.rotate_cw": "Rotar %0 +90",
	"action.rotate_cw.desc": "Rotar los cubos seleccionados 90º en el eje %0",
	"action.rotate_ccw": "Rotar %0 -90",
	"action.rotate_ccw.desc": "Rotar los cubos seleccionados -90º en el eje %0",
	"action.flip": "Voltear %0",
	"action.flip.desc": "Voltea los cubos seleccionados en el eje %0",
	"action.center": "Centrar %0",
	"action.center.desc": "Centra los cubos seleccionados en el eje %0",
	"action.bring_up_all_animations": "Subir Todas las Animaciones",
	"panel.bone": "Hueso",
	"data.color": "Color",
	"generic.export": "Exportar",
	"generic.none": "Ninguno",
	"status_bar.recording": "Grabando Timelapse",
	"message.add_to_palette": "Añadido a la paleta",
	"message.size_modifiers": "Mantén pulsado Ctrl o Shift para transformar en incrementos más pequeños",
	"message.timelapse_start": "Timelapse iniciado",
	"message.timelapse_stop": "Timelapse parado",
	"message.import_palette.replace_palette": "Reemplazar paleta vieja",
	"message.import_palette.threshold": "Unir Límite",
	"dialog.timelapse.interval": "Intervalo (Segundos)",
	"dialog.timelapse.source": "Fuente",
	"dialog.timelapse.source.interface": "Interfaz",
	"dialog.timelapse.source.locked": "Angulo Bloqueado",
	"dialog.timelapse.destination": "Carpeta de Destino",
	"layout.color.checkerboard": "Cuadrícula",
	"layout.color.checkerboard.desc": "Fondo del canvas y el editor de UV",
	"layout.font.code": "Fuente de Código",
	"layout.css": "CSS Personalizado",
	"settings.category.paint": "Pintar",
	"settings.deactivate_size_limit": "Desactivar Límite de Tamaño",
	"settings.deactivate_size_limit.desc": "Desactiva el límite de tamaño para algunos formatos de modelo. ADVERTENCIA: Esto puede crear modelos inválidos.",
	"settings.brush_opacity_modifier": "Modificador de Opacidad del Pincel",
	"settings.brush_opacity_modifier.desc": "Modifica la opacidad del pincel al usar un lápiz",
	"settings.brush_size_modifier": "Modificador de Tamaño del Pincel",
	"settings.brush_size_modifier.desc": "Modifica el tamaño del pincel al usar un lápiz",
	"settings.brush_modifier.pressure": "Presión",
	"settings.brush_modifier.tilt": "Inclinar",
	"category.color": "Color",
	"action.import_theme": "Importar Tema",
	"action.export_theme": "Exportar Tema",
	"action.export_theme.desc": "Crea un archivo de tema basado en la configuración actual",
	"action.slider_color_h": "Tono",
	"action.slider_color_s": "Saturación",
	"action.slider_color_v": "Valor",
	"action.add_to_palette": "Añadir a la Paleta",
	"action.add_to_palette.desc": "Añade el color seleccionado a la paleta de colores",
	"action.import_palette": "Importar Paleta",
	"action.import_palette.desc": "Importar un .bbpalette",
	"action.export_palette": "Exportar Paleta",
	"action.export_palette.desc": "Exporta la paleta como un archivo .GPL",
	"action.generate_palette": "Generar Paleta",
	"action.generate_palette.desc": "Genera la paleta a partir de una textura",
	"action.sort_palette": "Organizar Paleta",
	"action.sort_palette.desc": "Organiza todos los colores de la paleta por color y brillo",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Graba un timelapse de tu proceso de modelaje",
	"action.add_keyframe": "Añadir Fotograma Clave",
	"action.add_keyframe.desc": "Añade un fotograma clave al animador seleccionado",
	"action.bring_up_all_animations.desc": "Trae todos los animadores modificados a la línea de tiempo",
	"timeline.timeline": "Instrucciones",
	"menu.palette.load.default": "Por Defecto",
	"generic.import": "Importar",
	"settings.brush_modifier.none": "Ninguno",
	"action.export_entity": "Exportar Entidad de Bedrock",
	"action.export_entity.desc": "Añadir el modelo actual como una entidad a un archivo mobs.json",
	"settings.highlight_cubes": "Resaltar Cubos",
	"settings.highlight_cubes.desc": "Resaltar los cubos cuando pasas por encima de ellos o los seleccionas",
	"action.add_marker": "Poner Marcador",
	"action.add_marker.desc": "Pone un marcador de línea de tiempo",
	"timeline.pre_effect_script": "Guión",
	"format.skin": "Skin de Minecraft",
	"format.skin.desc": "Editar las skins de entidades y jugadores",
	"message.sketchfab.setup_guide": "¿Quieres aprender a preparar modelos en Sketchfab? Lee %0",
	"dialog.skin.title": "Crear Skin de Minecraft",
	"dialog.skin.model": "Modelo",
	"action.toggle_skin_layer": "Cambiar Capa de Skin",
	"action.toggle_skin_layer.desc": "Cambia la capa del gorro y de la ropa en el modelo de skin",
	"action.gui_light": "Luz en GUI",
	"action.gui_light.desc": "Selecciona la forma en la que el objeto es iluminado en el inventario",
	"action.gui_light.side": "Luz Lateral",
	"action.gui_light.front": "Luz Frontal",
	"action.move_keyframe_back": "Mover Fotogramas Clave Atrás",
	"action.move_keyframe_forth": "Mover Fotogramas Clave Adelante",
	"menu.help": "Ayuda",
	"menu.help.discord": "Servidor de Discord",
	"menu.help.report_issue": "Reportar un Problema",
	"menu.help.plugin_documentation": "Documentación de la API de Plugins",
	"menu.help.search_action": "Buscar y Ejecutar Acción",
	"menu.help.donate": "Donar",
	"menu.help.about": "Acerca de...",
	"menu.preview.background.clipboard": "Cargar desde Portapapeles",
	"dialog.ignore": "Ignorar",
	"generic.unset": "Desajustar",
	"message.invalid_builtin_parent.title": "Padre Incorporado Inválido",
	"message.invalid_builtin_parent.message": "El enlace al modelo inválido padre '%0' fue quitado para exportar un modelo válido.",
	"dialog.resize_texture.fill": "Rellenar con",
	"dialog.resize_texture.fill.transparent": "Transparente",
	"dialog.resize_texture.fill.color": "Color",
	"dialog.resize_texture.fill.repeat": "Repetir",
	"dialog.scale.element_pivot": "Pivote de Elemento",
	"dialog.scale.selection_center": "Centro de Selección",
	"dialog.create_gif.length_mode": "Modo de Longitud",
	"dialog.create_gif.length_mode.seconds": "Segundos",
	"dialog.create_gif.length_mode.frames": "Fotograma",
	"dialog.create_gif.length_mode.animation": "Longitud de Animación",
	"dialog.create_gif.length_mode.turntable": "Rotación de Bombero",
	"dialog.save_angle.projection": "Proyección",
	"dialog.save_angle.projection.perspective": "Perspectiva",
	"dialog.save_angle.projection.orthographic": "Ortogonal",
	"dialog.sketchfab_uploader.animations": "Animaciones",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Interfaz",
	"settings.preview_checkerboard": "Previsualizar Cuadrícula",
	"settings.preview_checkerboard.desc": "Cambia el fondo de la cuadrícula detrás de la vista previa",
	"settings.uv_checkerboard": "Cuadrícula del Editor de UV",
	"settings.uv_checkerboard.desc": "Cambia el fondo de la cuadrícula detrás del editor de UV",
	"category.paint": "Pintar",
	"action.fill_mode.color_connected": "Colores Conectados",
	"action.draw_shape_type": "Tipo de Forma",
	"action.draw_shape_type.rectangle": "Rectángulo",
	"action.draw_shape_type.rectangle_h": "Rectángulo (Hueco)",
	"action.draw_shape_type.ellipse": "Elipse",
	"action.draw_shape_type.ellipse_h": "Elipse (Hueca)",
	"action.draw_shape_type.line": "Línea",
	"action.mirror_painting": "Invertir Pintura",
	"action.mirror_painting.description": "Invierte tus trazos de pintura al otro lado del moedlo",
	"action.lock_alpha": "Bloquear Canal Alfa",
	"action.lock_alpha.description": "Bloquea la transparencia de todos los píxeles",
	"action.draw_shape_tool": "Dibujar Figura",
	"action.draw_shape_tool.desc": "Herramienta para dibujar figuras simples en texturas",
	"action.export_gltf": "Exportar como gITF",
	"action.export_gltf.desc": "Exporta el modelo y las animaciones como un archivo gITF para usarlo en otras aplicaciones 3D",
	"action.transform_space": "Transformar Espacio",
	"action.transform_space.desc": "Espacio de transformación por defecto para elementos y huesos",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Local",
	"action.toggle_camera_projection": "Cambiar Cámara de Proyección",
	"action.toggle_camera_projection.desc": "Cambia la cámara de proyección entre perspectiva y ortogonal",
	"action.load_camera_angle": "Ángulo de Cámara: %0",
	"action.load_camera_angle.desc": "Cargar el ángulo de cámara: '%0'",
	"action.slider_face_tint": "Índice de Tintado",
	"action.slider_face_tint.desc": "Ajusta el índice de tintado de la cara actual. -1 significa sin ajustar.",
	"menu.help.quickstart": "Asistente de Inicio Rápido",
	"menu.help.developer": "Desarrollador",
	"menu.help.developer.dev_tools": "Abre las Herramientas de Desarrollador",
	"menu.help.developer.reset_storage": "Reinicio de Fábrica",
	"menu.help.developer.reset_storage.confirm": "¿Seguro que quieres reiniciar Blockbench a los ajustes de fábrica? Esto borrará todos los ajustes personalizados, los atajos de teclado y los plugins instalados.",
	"menu.help.developer.cache_reload": "Recargar Caché",
	"menu.preview.orthographic": "Ortogonal",
	"menu.preview.save_angle": "Guardar Ángulo...",
	"menu.preview.angle": "Ángulos",
	"menu.preview.angle.initial": "Ángulo inicial",
	"menu.preview.maximize": "Maximizar",
	"uv_editor.copy_selection": "Copiar selección",
	"uv_editor.paste_selection": "Pegar selección",
	"uv_editor.copy_paste_tool.place": "Lugar",
	"uv_editor.copy_paste_tool.mirror_x": "Invertir X",
	"uv_editor.copy_paste_tool.mirror_y": "Invertir Y",
	"uv_editor.copy_paste_tool.rotate": "Rotar 90 Grados",
	"dialog.project.modded_entity_version": "Exportar Versión",
	"dialog.save_angle.position": "Posición de la Cámara",
	"dialog.save_angle.target": "Punto Focal",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Marco de Ventana",
	"layout.color.frame.desc": "Borde y barra de título de la ventana",
	"settings.large_grid_size": "Tamaño del Bloque de Cuadrícula",
	"settings.large_grid_size.desc": "Tamaño del bloque de la cuadrícula",
	"action.load_plugin_from_url": "Cargar Plugin desde URL",
	"action.load_plugin_from_url.desc": "Carga un plugin desde un servidor a través de una URL",
	"action.cube_counter.desc": "Muestra el número actual de cubos y otras estadísticas",
	"action.unlock_everything": "Desbloquear Todo",
	"action.unlock_everything.desc": "Desbloquea todos los grupos y elementos en el esquema.",
	"action.load_palette": "Cargar Paleta",
	"action.load_palette.desc": "Load one of the built-in or saved palette presets",
	"action.toggle_locked": "Cambiar Bloqueo",
	"action.toggle_locked.desc": "Cambiar si los elementos actuales están bloqueados o no",
	"action.apply_display_preset": "Aplicar Plantilla",
	"action.apply_display_preset.desc": "Aplica una plantilla de ajustes de visualización por defecto o personalizada",
	"action.apply_display_preset.here": "Aplicar A Este Apartado",
	"action.apply_display_preset.everywhere": "Aplicar A Todos los Apartados",
	"action.resolve_keyframe_expressions": "Resolver Fotogramas Clave",
	"action.resolve_keyframe_expressions.desc": "Resuelve las expresiones matemáticas de los fotogramas clave seleccionados",
	"action.fold_all_animations": "Plegar Todos los Animadores",
	"menu.palette.load.empty": "Vacío",
	"switches.lock": "Bloquear",
	"settings.render_sides": "Renderizar Lados",
	"settings.render_sides.desc": "Seleccionar qué lado de una cara es renderizado",
	"settings.render_sides.auto": "Automático",
	"settings.render_sides.front": "Exterior",
	"settings.render_sides.double": "Interior y Exterior",
	"generic.enable": "Activar",
	"generic.disable": "Desactivar",
	"generic.redacted": "Censurado",
	"dialog.select_texture.import_all": "Importar Todas",
	"dialog.skin.layer_template": "Textura de Capa",
	"about.version.up_to_date": "Actualizado",
	"about.version.update_available": "La versión %0 está disponible",
	"settings.category.application": "Aplicación",
	"settings.streamer_mode": "Modo Streamer",
	"settings.streamer_mode.desc": "Esconde información sensible como los modelos recientes",
	"settings.automatic_updates": "Actualizaciones Automáticas",
	"settings.automatic_updates.desc": "Actualiza automáticamente a nuevas versiones y mantenga Blockbench actualizado",
	"action.rotation_space": "Espacio de Rotación",
	"action.focus_on_selection": "Centrar Vista en Selección",
	"action.focus_on_selection.desc": "Ajusta la cámara para mirar hacia el centro de la selección actual",
	"action.jump_to_timeline_start": "Saltar a Inicio de Animación",
	"action.jump_to_timeline_end": "Saltar a Fin de Animación",
	"menu.help.updating": "Actualizando (%0%)",
	"menu.help.update_failed": "Actualización Fallida",
	"menu.animation.loop.once": "Reproducir Una Vez",
	"menu.animation.loop.hold": "Pausar en Último Fotograma",
	"menu.animation.loop.loop": "Repetir",
	"interface.streamer_mode_on": "Modo Streamer Activado",
	"generic.reset": "Reiniciar",
	"generic.restore": "Restaurar",
	"keys.mousewheel": "Rueda del Ratón",
	"message.delete_animation.title": "Eliminar animación",
	"message.delete_animation.message": "La animación se eliminó de Blockbench. ¿También desea eliminar la animación del archivo en el que se guardó?",
	"message.no_animation_to_import": "No hay animaciones para importar",
	"dialog.material_instances.title": "Instancias de material",
	"dialog.animation_import.title": "Seleccionar animaciones para importar",
	"dialog.create_texture.padding": "Relleno",
	"settings.fov": "FOV",
	"settings.fov.desc": "Campo de visión de la cámara. El valor por defecto es 45",
	"settings.minify_bbmodel": "Archivos de Projecto Minificados",
	"settings.minify_bbmodel.desc": "Escribe los archivos .bbmodel reducidos en una linea",
	"action.edit_material_instances": "Editar Instancias de Material",
	"action.edit_material_instances.desc": "Editar los nombres de instancias de material para geometrías de bloques de bedrock",
	"action.save_all_animations": "Guardar todas las animaciones",
	"action.save_all_animations.desc": "Guardar todas las animaciones abiertas en el momento",
	"action.keyframe_interpolation": "Interpolación",
	"action.keyframe_interpolation.desc": "Seleciona el modo de interpolacion de fotogramas",
	"action.keyframe_interpolation.linear": "Lineal",
	"action.keyframe_interpolation.catmullrom": "Liso",
	"action.timeline_focus.hide_empty": "Esconder canales vacíos",
	"menu.file.preferences": "Preferencias",
	"menu.animation.blend_weight": "Peso en union",
	"menu.animation.save": "Guardar",
	"menu.animation.properties": "Propiedades...",
	"menu.animation.file": "Archivo",
	"menu.animation.snapping": "Usar Imán",
	"menu.animation.open_location": "Mostrar en el Explorador de Archivos",
	"panel.keyframe.add_data_point": "Agregar punto de datos del Frame Clave",
	"panel.keyframe.remove_data_point": "Remover punto de datos",
	"panel.keyframe.pre": "Pre",
	"panel.keyframe.post": "Post",
	"generic.all": "Todo",
	"message.small_face_dimensions.title": "Dimensiones de Cara Incompatibles",
	"message.small_face_dimensions.message": "La selección contiene caras que son más pequeñas que 1 unidad en una dirección. El sistema del mapeo Box UV considera cualquier cara por debajo de ese umbral como 0 píxeles de ancho. Por lo tanto, es posible que la textura de esas caras no funcione correctamente.",
	"message.small_face_dimensions.face_uv": "El formato actual soporta mapas UV por Cara que pueden manejar caras de dimensiones pequeñas. Haz Clic Derecho en los cubos afectados y cambia el \"Modo UV\" a \"UV por Cara\".",
	"dialog.plugins.outdated_client": "Requiere una versión más reciente de Blockbench",
	"dialog.plugins.outdated_plugin": "El complemento está desactualizado y no funciona con esta versión de Blockbench",
	"settings.motion_trails": "Rastros de Movimiento",
	"settings.motion_trails.desc": "Mostrar rastros de movimiento en el editor de animación",
	"settings.antialiasing": "Anti-aliasing",
	"settings.antialiasing.desc": "Alternar el anti-aliasing en la vista previa",
	"action.timeline_frame_back": "Avanza un fotograma atras",
	"action.timeline_frame_forth": "Avanza un fotograma adelante",
	"panel.bone.ik": "Cinemáticas inversas (Experimental)",
	"settings.particle_tick_rate": "Frecuencia de Actualización de Partículas",
	"settings.particle_tick_rate.desc": "Frecuencia de actualización de los efectos de partículas en ticks por segundo. El valor por defecto es 30",
	"action.lock_motion_trail": "Bloquear el rastro de movimiento",
	"action.lock_motion_trail.desc": "Bloquear el rastro de movimiento en el grupo seleccionado",
	"menu.animation_file.unload": "Descargar Archivo",
	"data.null_object": "Objeto Nulo",
	"status_bar.toggle_sidebar": "Mostrarbarralateral",
	"message.load_plugin_failed.title": "Falló al cargar el plugin",
	"message.load_plugin_failed.message": "Asegúrate que el nombre del archivo del plugin corresponde al ID `%0`, tal como se especifica en Plugin.Register().",
	"dialog.project.uv_mode": "Modo UV",
	"dialog.project.uv_mode.box_uv": "Caja UV ",
	"dialog.project.uv_mode.face_uv": "UV por Cara",
	"dialog.project.texture_size": "Tamaño de la textura",
	"dialog.animation_export.title": "Selecciona animaciones a exportar",
	"dialog.create_texture.rearrange_uv": "UV de arranque",
	"layout.color.subtle_text": "Texto Subtítulo",
	"layout.color.subtle_text.desc": "Color del texto secundario con menos contraste",
	"settings.interface_scale": "Escala de la Interfaz",
	"settings.interface_scale.desc": "Escala de la interfaz de Blockbench",
	"settings.background_rendering": "Renderizado del Fondo",
	"settings.background_rendering.desc": "Actualiza la vista previa mientras la ventana no esté enfocada",
	"settings.ctrl_shift_size": "Resolución de Control + Shift",
	"settings.ctrl_shift_size.desc": "Resolución del mapa mientras mantienes presionado control y shift",
	"settings.hardware_acceleration": "Aceleración de Hardware",
	"settings.hardware_acceleration.desc": "Externaliza las tareas de renderizado a la tarjeta gráfica",
	"action.explode_skin_model": "Expandir Modelo de Skin",
	"action.explode_skin_model.desc": "Alternar a una vista de explosión que le permite editar caras cubiertas",
	"action.export_minecraft_skin": "Exportar Skin de Minecraft",
	"action.export_minecraft_skin.desc": "Exportar la Skin de Minecraft como una textura PNG",
	"action.add_null_object": "Agregar un objeto nulo",
	"action.add_null_object.desc": "Agrega un nuevo objeto nulo",
	"action.animated_texture_frame": "Fotograma de Texturas Animadas",
	"action.animated_texture_frame.desc": "Posicionar el fotograma actual en la textura animada",
	"action.export_animation_file": "Exportar animaciones...",
	"action.export_animation_file.desc": "Exportar una selección de animaciones a un nuevo archivo",
	"action.timeline_graph_editor": "Editor gráfico",
	"action.timeline_graph_editor.desc": "Alternar a la línea de tiempo entre la vista del editor de gráficos y la vista de fotogramas clave",
	"menu.file.recent.clear": "Limpiar archivos recientes",
	"switches.shade": "Sombra",
	"generic.share": "Compartir",
	"dates.minute": "%0 Minuto",
	"dates.minutes": "%0 Minutos",
	"dates.hour": "%0 Hora",
	"dates.hours": "%0 Horas",
	"dates.day": "%0 Día",
	"dates.days": "%0 Días",
	"dates.week": "%0 Semana",
	"dates.weeks": "%0 Semanas",
	"dates.year": "%0 Año",
	"dates.years": "%0 Años",
	"message.installed_plugin": "Exitosamente instalado el plugin %0",
	"message.installed_plugin_fail": "Falló la instalación del plugin %0",
	"dialog.share_model.title": "Compartir Modelo",
	"dialog.share_model.expire_time": "Tiempo de Expiración",
	"dialog.share_model.failed": "Falló la subida del modelo",
	"action.import_java_block_model": "Añade un Modelo de Bloque/Objeto de Java",
	"action.import_java_block_model.desc": "Añade un Modelo de Bloque/Objeto de Minecraft Java desde un archivo json al modelo actual",
	"action.share_model": "Compartir...",
	"action.share_model.desc": "Genera un enlace corto para compartir tu modelo",
	"action.import_project": "Importar Proyecto",
	"action.import_project.desc": "Importar otro proyecto desde un archivo .bbmodel al proyecto actual",
	"dialog.toolbar_edit.hidden_tools": "Algunas herramientas podrían estar ocultas porque no están disponibles en el modo, formato o situación actual.",
	"settings.camera_near_plane": "Cámara Cerca del Plano",
	"settings.camera_near_plane.desc": "La distancia mínima desde la cámara a la que se renderizan los objetos. Los valores más altos reducen el Z-fighting. El valor por defecto es 1.",
	"mode.start.keymap_preference.desc": "Si eres nuevo en Blockbench y vienes de otro programa en 3D, puedes seleccionar un mapa de teclas para hacer mas fácil tu transición. Puedes cambiar este mapa de teclas o los atajos de teclado individuales después en las configuraciones.",
	"message.load_keymap": "¿Estás seguro que quieres cargar este mapa de teclas? Esto sobreescribirá tus actuales atajos de teclado.",
	"message.keymap_loaded": "Mapa de Teclas cargado",
	"dialog.convert_project.current_format": "Formato Actual",
	"dialog.create_texture.rearrange_uv.desc": "Crear una nueva UV de arreglo para otorgar a cada cara un lugar único en la textura",
	"dialog.create_texture.power.desc": "Bloquea la textura automática al tamaño de poder-de-2, de 64 o 128. Esto requiere varios renderizados",
	"dialog.create_texture.double_use.desc": "Si dos elementos tienen el mismo espacio del UV asignado, mantenlo así para un nuevo mapa",
	"dialog.create_texture.padding.desc": "Añadir un pequeño relleno entre partes individuales de la plantilla",
	"dialog.create_texture.resolution.desc": "El tamaño y la altura de la textura",
	"dialog.create_gif.color": "Color del Fondo",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Los huesos opuestos están identificados a \"Izquierda\" y \"Derecha\" sin su nombre.",
	"dialog.export_private_settings.title": "Configuración privada",
	"dialog.export_private_settings.message": "Tu archivo contiene la siguiente información privada: **%0**. Deje estos valores fuera si planea compartir este archivo con alguien más.",
	"dialog.export_private_settings.keep": "Mantener",
	"settings.timecode_frame_number": "Mostrar Códigos de Tiempo como Números de Fotograma",
	"settings.timecode_frame_number.desc": "Mostrar los códigos de tiempo fraccionarios en la línea de tiempo como números de fotograma en lugar de centésimas de segundo",
	"settings.animation_sample_rate": "Frecuencia de Muestreo de Animación",
	"settings.animation_sample_rate.desc": "Frecuencia de muestreo en muestras por segundo para curvas que el formato respectivo no soporta de manera nativa",
	"keybind.preview_zoom": "Vista de zoom",
	"action.gradient_tool": "Herramienta de Gradiente",
	"action.gradient_tool.desc": "Crea un gradiente de un color en tu textura",
	"action.import_settings": "Importar Configuraciones",
	"action.import_settings.desc": "Importar un archivo .bbsettings",
	"action.export_settings": "Exportar Configuraciones",
	"action.export_settings.desc": "Exportar las configuraciones de Blockbench como archivos .bbsettings",
	"action.load_keymap": "Cargar Mapa de Teclas",
	"action.load_keymap.default": "Por Defecto (Panel Táctil/Mouse)",
	"action.load_keymap.mouse": "Por Defecto (Mouse)",
	"action.load_keymap.default.desc": "Atajos de teclado por defecto de Blockbench, con controles de navegación de ventana gráfica optimizados para su uso en paneles táctiles de laptops",
	"action.load_keymap.mouse.desc": "Combinaciones de teclas predeterminadas de Blockbench, con la navegación de la ventana gráfica vinculada al botón del medio del ratón",
	"action.load_keymap.blender.desc": "Mapa de Teclas para usuarios que están familiarizados con los controles de Blender",
	"action.load_keymap.cinema4d.desc": "Mapa de Teclas para usuarios que están familiarizados con los controles de Cinema 4D",
	"action.load_keymap.maya.desc": "Mapa de Teclas para usuarios que estan familiarizados con los controles de Autodek Maya",
	"action.import_keymap": "Importar Mapa de Teclas",
	"action.import_keymap.desc": "Importar atajos de teclado a un archivo .bbkeymap",
	"action.export_keymap": "Exportar Mapa de Teclas",
	"action.export_keymap.desc": "Exportar los actuales atajos de teclado como un archivo .bbkeymap",
	"action.edit_history": "Editar Historial...",
	"action.edit_history.desc": "Ver el historial de edición y deshacer o rehacer pasos",
	"action.group_elements": "Elementos del Grupo",
	"action.group_elements.desc": "Envolver los elementos seleccionados a un nuevo grupo",
	"action.unfold_groups": "Desplegar Grupos",
	"action.unfold_groups.desc": "Desplegar todos los grupos en el esquema",
	"action.edit_bedrock_binding": "Editar Unión...",
	"action.edit_bedrock_binding.desc": "Cambiar a qué hueso está unida la geometría",
	"action.pick_screen_color": "Seleccionar color en pantalla",
	"action.pick_screen_color.desc": "Seleccionar un color de la pantalla",
	"action.view_mode": "Modo de Vista",
	"action.view_mode.desc": "Cambiar el modo de vista del modelo",
	"action.view_mode.textured": "Texturado",
	"action.view_mode.solid": "Solido",
	"action.view_mode.wireframe": "Estructura",
	"action.toggle_sidebars": "Alternar las barras laterales",
	"action.toggle_sidebars.desc": "Habilitar o inhabilitar las barras laterales",
	"action.set_animation_end": "Establecer el final en la animación",
	"action.set_animation_end.desc": "Establecer el final de la animación seleccionada en el periodo de tiempo seleccionado",
	"action.flip_animation": "Voltear animación",
	"action.flip_animation.desc": "Voltea parte de una animación copiando fotogramas clave seleccionados al otro lado del modelo",
	"action.graph_editor_zero_line": "Incluir línea cero",
	"action.graph_editor_zero_line.desc": "Si el editor de gráficos siempre incluye la línea cero en la vista",
	"menu.texture.render_mode": "Modo de Renderización",
	"menu.texture.render_mode.emissive": "Emisivo",
	"menu.texture.render_mode.layered": "En capas",
	"menu.preview.angle.edit": "Editar Ángulo...",
	"menu.animation.start_delay": "Empezar Desfase",
	"menu.animation.loop_delay": "Repetir Desfase",
	"menu.animation.flip_keyframes": "Voltear Fotogramas",
	"menu.mobile_keyboard.disable_all": "Desactivar Todo",
	"panel.keyframe.toggle_uniform_scale": "Cambiar Reescalado Uniforme",
	"camera_angle.common_isometric_right": "Isométrico derecho (2:1)",
	"camera_angle.common_isometric_left": "Isométrico izquierdo (2:1)",
	"camera_angle.true_isometric_right": "Isométrico correcto derecho (30 grados)",
	"camera_angle.true_isometric_left": "Isométrico correcto izquierdo (30 grados)",
	"menu.help.wiki": "Wiki de BlockBench",
	"settings.update_to_prereleases": "Actualizar a una Versión Preliminar",
	"settings.update_to_prereleases.desc": "Actualiza automáticamente a una versión beta de Blockbench para probar nuevas características. Las versiones Preliminares pueden ser inestables, NO ACTIVES esta opción si confía en Blockbench para el trabajo u otros proyectos importantes.",
	"data.separator.spacer": "Espaciador",
	"data.separator.linebreak": "Salto de línea",
	"data.setting": "Configuraciones",
	"generic.select_all": "Seleccionar Todo",
	"generic.select_none": "Seleccionar Nada",
	"projects.new_tab": "Nueva Pestaña",
	"projects.close_tab": "Cerrar Pestaña",
	"message.invalid_format.title": "Formato Inválido",
	"message.invalid_format.message": "Este modelo fue hecho en el formato '%0', el cual no está disponible en tu instalación de Blockbench. Lo mas probable es que necesite un complemento en específico para abrirlo correctamente",
	"message.invalid_link": "Link del Modelo Inválido o Expirado",
	"message.default_textures.current": "Ruta actual",
	"message.update_after_restart": "La actualización será instalada después del próximo reinicio",
	"message.copy_paste_tool_viewport": "Esta herramienta sólo puede utilizarse en el editor 2D",
	"dialog.project.shadow_size": "Tamaño de la Sombra",
	"dialog.find_replace.target": "Objetivo",
	"dialog.find_replace.target.element_names": "Nombres de los Elementos",
	"dialog.find_replace.target.group_names": "Nombres de los Grupos",
	"dialog.find_replace.target.animation_names": "Nombres de las Animaciones",
	"dialog.find_replace.target.keyframe_values": "Valor de los Fotogramas",
	"dialog.find_replace.find": "Buscar",
	"dialog.find_replace.replace": "Reemplazar",
	"dialog.find_replace.regex": "Expresión regular",
	"dialog.add_primitive.shape": "Forma",
	"dialog.add_primitive.shape.circle": "Circulo",
	"dialog.add_primitive.shape.tube": "Tubo",
	"dialog.add_primitive.shape.cone": "Cono",
	"dialog.add_primitive.shape.cylinder": "Cilindro",
	"dialog.add_primitive.shape.sphere": "Esfera",
	"dialog.add_primitive.shape.torus": "Toro",
	"dialog.add_primitive.shape.cube": "Cuboide",
	"dialog.add_primitive.shape.pyramid": "Pirámide",
	"dialog.add_primitive.diameter": "Diámetro",
	"dialog.add_primitive.height": "Altura",
	"dialog.add_primitive.sides": "Lados",
	"dialog.add_primitive.minor_diameter": "Espesor",
	"dialog.add_primitive.minor_sides": "Lador Menores",
	"dialog.create_texture.combine_polys": "Combinar Islas",
	"dialog.create_texture.combine_polys.desc": "Combinar caras en islas UV conectadas",
	"dialog.model_stats.meshes": "Mallas",
	"dialog.export_private_settings.omit": "Salir",
	"layout.select": "Seleccionar",
	"layout.options": "Opciones",
	"layout.color": "Esquema de Colores",
	"layout.documentation": "Documentación",
	"layout.color.bright_ui_text": "Texto de UI Brillante",
	"layout.color.bright_ui_text.desc": "Texto en fondos brillantes",
	"layout.name": "Nombre",
	"layout.author": "Autor",
	"settings.dialog.desc": "Muestra el dialogo \"%0\"",
	"settings.export_empty_groups": "Exportar Grupos Vacíos",
	"settings.export_empty_groups.desc": "Incluir grupos sin contenido en archivos exportados",
	"category.separators": "Separadores",
	"keybind.preview_area_select": "Área de Selección",
	"action.color_erase_mode": "Modo Borrar",
	"action.color_erase_mode.desc": "Con el modo borrar activado, las herramientas como Llenar y Rectángulo quitan colores en vez de agregarlos",
	"action.open_from_link": "Abrir modelo desde el Link...",
	"action.open_from_link.desc": "Abrir un modelo desde un blckbn.ch URL",
	"action.import_obj": "Importar Modelo OBJ",
	"action.import_obj.desc": "Importar objetos de un modelo OBJ como una malla",
	"action.add_plugin": "Instalar Plugin",
	"action.add_plugin.desc": "Instala un plugin mediante un Control de Acción",
	"action.remove_plugin": "Desinstalar Plugin",
	"action.remove_plugin.desc": "Desinstala un plugin mediante un Control de Acción",
	"action.add_mesh": "Añadir Malla",
	"action.add_mesh.desc": "Añade una nueva malla",
	"action.add_texture_mesh": "Añadir Malla de Textura",
	"action.add_texture_mesh.desc": "Añade una nueva malla de textura",
	"action.find_replace": "Encontrar/Reemplazar...",
	"action.find_replace.desc": "Encontrar y reemplazar partes de los nombres",
	"action.hide_everything_except_selection": "Ocultar todo excepto la selección",
	"action.hide_everything_except_selection.desc": "Alternar la visualización en todos los elementos excepto los seleccionados",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Modo de Selección",
	"action.selection_mode.desc": "Cambiar cómo los elementos pueden ser seleccionados en el punto de mira",
	"action.selection_mode.object": "Objeto",
	"action.selection_mode.face": "Cara",
	"action.selection_mode.vertex": "Vértice",
	"action.create_face": "Crear Cara o Borde",
	"action.create_face.desc": "Crea una nueva cara o borde entre los vértices seleccionados",
	"action.convert_to_mesh": "Convertir a Malla",
	"action.convert_to_mesh.desc": "Convertir los elementos seleccionados a mallas",
	"action.invert_face": "Invertir Cara",
	"action.invert_face.desc": "Invierte las caras seleccionadas para que miren en la dirección opuesta",
	"action.extrude_mesh_selection": "Extruir Selección",
	"action.extrude_mesh_selection.desc": "Extruir las partes seleccionadas de la malla",
	"action.loop_cut": "Corte de Bucle",
	"action.loop_cut.desc": "Divida la malla en un bucle a través del borde seleccionado",
	"action.merge_meshes": "Unir mallas",
	"action.merge_meshes.desc": "Combinar varias mallas en una",
	"action.keyframe_uniform": "Escalar uniforme",
	"action.keyframe_uniform.desc": "Habilite el escalado uniforme en los fotogramas clave seleccionados",
	"menu.locator.ignore_inherited_scale": "Ignorar escalado heredado",
	"menu.texture.elements": "Aplicar a Elementos",
	"uv_editor.transparent_face": "Transparentar Cara",
	"display.pose_angle": "Ángulo de Pose (Solo para Vista Previa)",
	"data.mesh": "Malla",
	"dialog.create_texture.type": "Tipo",
	"dialog.create_texture.type.blank": "En Blanco",
	"dialog.create_texture.type.template": "Plantilla de textura",
	"dialog.create_texture.type.color_map": "Plantilla de Color Sólido",
	"dialog.sketchfab_uploader.suggested_tags": "Etiquetas sugeridas",
	"dialog.sketchfab_uploader.category": "Categoría",
	"dialog.sketchfab_uploader.category2": "Categoría 2",
	"layout.restore_backup": "Tu tema personalizado %0 fue sobreescrito. Clickea aquí para restaurarlo",
	"layout.borders": "Bordes",
	"action.fill_mode.element": "Elemento",
	"action.inset_mesh_selection": "Insertar Selección",
	"action.inset_mesh_selection.desc": "Inserta las partes seleccionadas de la malla",
	"action.dissolve_edges": "Disolver Bordes",
	"action.dissolve_edges.desc": "Disolver los bordes seleccionados en una malla y fusionar las caras que dividen",
	"action.split_mesh": "Separar mallas",
	"action.split_mesh.desc": "Separar las mallas seleccionadas en una nueva malla",
	"action.merge_vertices": "Combinar vértices",
	"action.merge_vertices.desc": "Fusionar los vértices seleccionados en la posición del primer vértice seleccionado",
	"action.view_mode.normal": "Orientación de Cara",
	"action.snap_uv_to_pixels": "Cambiar UV a píxeles",
	"action.snap_uv_to_pixels.desc": "Ajusta los vértices UV seleccionados a la cuadrícula de píxeles",
	"menu.file.import.import_open_project": "Importar proyecto abierto",
	"menu.help.unlock_projects": "Desbloquea todos los proyectos",
	"status_bar.selection.faces": "%0 Caras",
	"status_bar.selection.vertices": "%0 Vertices",
	"message.merged_vertices": "Se encontraron y combinaron %0 vértices en %1 ubicaciones",
	"settings.vertex_merge_distance": "Distancia de Fusión de Vértices",
	"settings.vertex_merge_distance.desc": "Distancia dentro de la cual se fusionan los vértices mediante la fusión por distancia",
	"settings.show_only_selected_uv": "Mostrar Solo UV Seleccionado",
	"settings.show_only_selected_uv.desc": "Mostrar solo las caras UV seleccionadas en el editor UV por defecto",
	"action.merge_vertices.merge_all": "Unir todo",
	"action.merge_vertices.merge_all_in_center": "Unir todo al centro",
	"action.merge_vertices.merge_by_distance": "Unir distancia",
	"action.merge_vertices.merge_by_distance_in_center": "Unir distancia al centro",
	"action.uv_rotate_left": "Rotar UV a la izquierda",
	"action.uv_rotate_left.desc": "Rotar las caras UV seleccionadas en sentido anti-horario (izquierda)",
	"action.uv_rotate_right": "Rotar las caras UV a la derecha",
	"action.uv_rotate_right.desc": "Rotar las caras UV seleccionadas en sentido horario (derecha)",
	"menu.uv.display_uv": "Mostrar UV",
	"menu.uv.display_uv.selected_faces": "Caras seleccionadas",
	"menu.uv.display_uv.selected_elements": "Todas las caras",
	"menu.uv.display_uv.all_elements": "Todas las caras en todos los elementos",
	"menu.paste.face": "Cara UV",
	"menu.paste.mesh_selection": "Selección de Malla",
	"menu.paste.outliner": "Elementos",
	"uv_editor.show_all_faces": "Mostrar todas las caras",
	"uv_editor.show_selected_faces": "Mostrar las caras seleccionadas",
	"status_bar.selection.edges": "0% de ejes",
	"action.selection_mode.edge": "Eje",
	"message.cannot_re_import.title": "Modelo no puede ser re-importado",
	"message.cannot_re_import.message": "El modelo del formato exportado no puede ser importado a BlockBench nuevamente. Por favor asegurate de guardar tu modelo como un archivo de proyecto.",
	"generic.default": "Por defecto",
	"units.pixels_per_meter": "%0 píxeles por metro",
	"mode.pose": "Pose",
	"modifier_actions.resize_both_sides": "Reescalar en ambas direcciones",
	"modifier_actions.resize_one_side": "Reescalar en una sola dirección",
	"modifier_actions.draw_line": "Dibujar línea",
	"modifier_actions.drag_without_snapping": "Arrastar sin romper",
	"modifier_actions.stretch_keyframes": "Estirar fotogramas clave",
	"modifier_actions.resize_background": "Reescalar fondo",
	"modifier_actions.select_multiple": "Selección múltiple",
	"modifier_actions.select_range": "Seleccionar rango",
	"modifier_actions.drag_to_duplicate": "Arrastar para duplicar",
	"modifier_actions.uniform_scaling": "Escalado uniforme",
	"modifier_actions.snap_direction": "Quebrar la dirección",
	"message.no_valid_elements": "Los elementos seleccionados no son válidos",
	"dialog.add_primitive.shape.plane": "Plano",
	"dialog.save_angle.rotation_mode": "Modo de Rotación",
	"dialog.save_angle.rotation": "Rotación",
	"dialog.save_angle.fov": "Campo de visión",
	"settings.hide_tab_bar": "Ocultar Barra de Pestañas Automáticamente",
	"settings.hide_tab_bar.desc": "Ocultar la barra de pestañas cuando solo hay una pestaña abierta",
	"settings.status_bar_modifier_keys": "Sugerir Teclas Modificadoras en la Barra de Estado",
	"settings.status_bar_modifier_keys.desc": "Mostrar teclas modificadoras, sugeridas según el contexto en la barra de estado",
	"settings.ground_plane": "Plano del Suelo",
	"settings.ground_plane.desc": "Mostrar un plano del suelo debajo del modelo",
	"settings.preview_paste_behavior": "Comportamiento Por Defecto al Pegar en la Ventana Gráfica",
	"settings.preview_paste_behavior.desc": "Seleccione el comportamiento al pegar algo en la ventana gráfica en el Modo Edición. Hay varias opciones disponibles",
	"settings.preview_paste_behavior.always_ask": "Siempre Pregunta",
	"action.new_window": "Nueva ventana",
	"action.new_window.desc": "Abrir una nueva ventana en Blockbench",
	"action.export_collada": "Exportar modelo Collada (dae)",
	"action.export_collada.desc": "Exportar modelo y animaciones como archivo dae para usarlo en otras aplicaciones 3D",
	"action.paint_mode_uv_overlay": "Cubrir UV",
	"action.paint_mode_uv_overlay.desc": "Muestra el mapa UV como una superposición en el modo de pintura",
	"action.bake_animation_into_model": "Hornear animación en modelo",
	"action.bake_animation_into_model.desc": "Hornea la animación mostrada actualmente al modelo. Solo aplica a la rotación y la posición, se ignora la escala.",
	"action.keyframe_interpolation.step": "Paso",
	"action.set_ik_target": "Fijar objetivo IK",
	"action.set_ik_target.desc": "Seleccione el hueso de destino que debe ser movido por este objeto nulo a través de cinemática inversa",
	"menu.action_control.type.tab": "Tabulador",
	"menu.action_control.type.angle": "Ángulo de Cámara",
	"menu.action_control.recent_in_streamer_mode": "¿Seguro? El modo streamer está habilitado",
	"menu.action_control.recent_in_streamer_mode.desc": "¿Estás seguro de que quieres mostrar los modelos recientes?",
	"menu.tools": "Objetos",
	"menu.file.recent.more": "Ver más...",
	"menu.null_object.lock_ik_target_rotation": "Bloquear rotación IK",
	"menu.animation_file.import_remaining": "Importar animaciones restantes",
	"edit.loop_cut.offset": "Compensar",
	"edit.extrude_mesh_selection.extend": "Extender",
	"cube.color.pink": "Rosa",
	"cube.color.silver": "Gris claro",
	"dialog.plugins.offline": "Sin conexión a Internet",
	"dialog.create_texture.pixel_density": "Densidad del píxel",
	"dialog.create_texture.pixel_density.desc": "La densidad del píxel en la textura, en píxeles por metro. El tamaño del mapa de la textura puede diferenciar dependiendo de el tamaño y la cantidad de elementos",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "Nada",
	"panel.skin_pose.natural": "Naturar",
	"panel.skin_pose.walking": "Caminando",
	"panel.skin_pose.crouching": "Acechando",
	"panel.skin_pose.sitting": "Sentado",
	"panel.skin_pose.jumping": "Saltando",
	"panel.skin_pose.aiming": "Apuntando",
	"edit.loop_cut.direction": "Dirección",
	"data.texture_mesh": "Malla de textura",
	"generic.left": "Izquierda",
	"generic.right": "Derecha",
	"mode.start.quick_setup": "Armado rápido",
	"mode.start.keymap": "Keymap",
	"mode.start.quick_setup.more_themes": "Más...",
	"dialog.resize_texture.animation_frames": "Fotograma de animación",
	"dialog.export_emission_map.title": "Exportar Emission Map",
	"dialog.export_emission_map.format": "Formato",
	"dialog.export_emission_map.format.luminance": "Luminiscencia",
	"dialog.export_emission_map.format.luminance_inverted": "Luminiscencia invertida",
	"dialog.export_emission_map.format.colors": "Colores",
	"dialog.export_emission_map.threshold": "Umbral de Transparencia",
	"dialog.export_emission_map.round_up": "Redondear a %0 x %1",
	"dialog.export_emission_map.flip_y": "Invertir Eje Y",
	"dialog.select.type": "Tipo de elemento",
	"dialog.create_texture.max_edge_angle": "Umbral de Ángulo de Borde",
	"dialog.create_texture.max_edge_angle.desc": "El ángulo máximo entre dos caras que se pueden combinar",
	"dialog.create_texture.max_island_angle": "Umbral de Ángulo de Isla UV",
	"dialog.create_texture.max_island_angle.desc": "El ángulo máximo que se puede combinar en la misma isla UV",
	"settings.mobile_panel_side": "Panel lateral móvil",
	"settings.mobile_panel_side.desc": "Seleccione en qué lado de la pantalla se mostrarán los paneles al usar Blockbench en orientación horizontal",
	"settings.obj_face_export_mode": "Modo de Exportación de Caras OBJ",
	"settings.obj_face_export_mode.desc": "Seleccione si desea que el exportador OBJ convierta todas las caras en triángulos o cuadriláteros",
	"settings.obj_face_export_mode.both": "Por Defecto",
	"settings.obj_face_export_mode.tris": "Convertir a Triángulos",
	"settings.obj_face_export_mode.quads": "Convertir a Cuadriláteros",
	"action.seam_tool": "Herramienta de Costura",
	"action.seam_tool.desc": "Herramienta para definir costuras UV en los bordes de la malla",
	"action.resolve_group": "Resolver Grupo",
	"action.resolve_group.desc": "Resolver el grupo manteniendo sus elementos secundarios en el mismo lugar",
	"action.move_to_group": "Mover a Grupo",
	"action.move_to_group.desc": "Mueve los elementos seleccionados a un grupo diferente",
	"action.select_seam": "Seleccionar Costura UV",
	"action.select_seam.desc": "Seleccione el modo de costura UV para los bordes seleccionados",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Unir",
	"action.select_seam.divide": "Dividir",
	"action.adjust_brightness_contrast": "Ajustar Brillo y Contraste",
	"action.adjust_brightness_contrast.desc": "Ajusta el brillo y contraste de la textura seleccionada",
	"action.adjust_saturation_hue": "Ajustar saturación y hue...",
	"action.adjust_saturation_hue.desc": "Ajusta la saturación y el hue de la textura seleccionada",
	"action.invert_colors": "Invertir Colores",
	"action.invert_colors.desc": "Invertir todos los colores de la textura seleccionada",
	"action.adjust_curves": "Ajustar curvas...",
	"action.adjust_curves.desc": "Ajusta las curvas de brillo de la textura seleccionada",
	"action.flip_texture_x": "Invertir Textura Horizontalmente",
	"action.flip_texture_y": "Invertir Textura Verticalmente",
	"action.resize_texture": "Reescalar Textura...",
	"action.view_mode.uv": "Vista Previa UV",
	"action.append_to_template": "Añadir elementos a la plantilla...",
	"action.append_to_template.desc": "Añadir los elementos actualmente seleccionados a la plantilla de textura",
	"action.move_texture_with_uv": "Mover textura con UV",
	"action.move_texture_with_uv.desc": "Mueve la textura de la cara al arrastrar las caras UV",
	"action.timeline_setups": "Configuraciones de Líneas de Tiempo",
	"action.save_timeline_setup": "Guardar Configuración de la Línea de Tiempo...",
	"action.save_timeline_setup.desc": "Guarda una plantilla de los animadores y canales seleccionados",
	"menu.texture": "Textura",
	"menu.texture.render_mode.default": "Por Defecto",
	"menu.texture.merge_onto_texture": "Combinar con la Textura Encima",
	"menu.animation.unload": "Descargar",
	"panel.timeline": "Línea de Tiempo",
	"action.pan_tool": "Herramienta de Desplazamiento",
	"action.pan_tool.desc": "Herramienta para navegar en la ventana gráfica (viewport) y el editor de texturas",
	"mode.start.recent.favorite": "Señalar como Favorito",
	"mode.start.info": "Información",
	"mode.start.target": "Objetivo",
	"mode.start.start": "Iniciar",
	"mode.start.create_new": "Crear Nuevo Modelo",
	"mode.start.format.informations": "Importante:",
	"mode.start.format.resources": "Recursos:",
	"format.free.info.meshes": "En este formato, puedes crear modelos low poly usando cubos y mallas con formas personalizadas.",
	"format.free.info.limitation": "Estos modelos no pueden ser usados en juegos que requieran formatos especializados, como Minecraft.",
	"format.skin.info.skin": "Este formato está diseñado para crear skins de Minecraft y texturas para entidades.",
	"format.skin.info.model": "Estos modelos no pueden ser modificados. Para realizar cambios, primero convierta a un formato diferente con **Archivo** > **Convertir Projecto**.",
	"format.java_block.info.rotation": "Las rotaciones están limitadas a incrementos de 22.5 grados y a solo un eje por cada elemento",
	"format.java_block.info.size": "El modelo está limitado a un tamaño de 3 por3 por 3 bloques. Sin embargo, los ajustes de visualización pueden hacer que los objetos parezcan más grandes",
	"format.java_block.info.animation": "Este formato no admite animaciones en Minecraft vanilla. Si estas creando un mod, puedes usar Geckolib para animar modelos. Si no, la única manera de animar es intercambiar el modelo usando comandos o texturas animadas.",
	"format.bedrock.info.textures": "Cada modelo solo puede usar una textura",
	"format.bedrock_block": "Bloque de Bedrock",
	"format.bedrock_block.desc": "Modelo de Bloque para Minecraft Bedrock",
	"format.modded_entity.info.integer_size": "El tamaño de cubos esta limitado a integrales.",
	"format.modded_entity.info.format": "Los modelos son escritos en código java en vez de estructuras de datos como el resto de formatos de exportación de Blockbench.",
	"format.optifine_entity.info.optifine_required": "Usuarios sin OptiFine instalado no podrán ver el modelo.",
	"format.optifine_entity.info.pivots": "Los pivotes de los huesos están bloqueados, es buena idea dejarlos sin modificar.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Otros",
	"format_category.loaders": "Cargadores",
	"message.recover_backup.recover": "Recuperar",
	"message.invalid_characters.title": "Ruta Inválida",
	"message.invalid_characters.message": "La ruta del archivo importado contiene caracteres inválidos, letras mayúsculas, o espacios. Los caracteres permitidos son: %0",
	"dialog.share_model.thumbnail": "Miniatura",
	"dialog.skin.high_res_texture": "Ten en cuenta que las skins con esta resolución seleccionada no funcionarán como skins normales de Minecraft. Selecciona una resolución más baja.",
	"settings.allow_display_slot_mirror": "Permitir Duplicación de Ranuras de Visualización",
	"settings.allow_display_slot_mirror.desc": "Permite duplicar las ranuras de visualización para los modelos de elementos Java. ADVERTENCIA: Esto solo funciona en Minecraft 1.14 o versiones anteriores, o en casos especiales.",
	"action.switch_tabs": "Intercambiar pestañas",
	"action.switch_tabs.desc": "Cambia entre las pestañas abiertas. Mantén pulsada la tecla Mayús o Shift para cambiar en la dirección opuesta.",
	"action.unselect_all": "Deseleccionar todo",
	"action.save_palette": "Guardar Paleta...",
	"action.save_palette.desc": "Guarda la paleta de colores actual dentro de Blockbench para uso posterior",
	"action.keyframe_column_create": "Crear Columna de Fotogramas Clave",
	"action.keyframe_column_create.desc": "Añadir fotogramas clave a todos los canales de la línea de tiempo, en el código de tiempo actual, si ya tienen fotogramas clave",
	"action.keyframe_column_select": "Seleccionar Columna de Fotogramas Clave",
	"action.keyframe_column_select.desc": "Seleccione todos los fotogramas clave de la columna situada debajo del cabezal de reproducción en la línea de tiempo",
	"menu.uv": "UV",
	"menu.keyframe": "Fotogramas",
	"menu.palette.load.update": "Actualizar Paleta",
	"menu.palette.load.update.desc": "Actualiza esta paleta con los colores de la paleta actual de Blockbench",
	"menu.timeline_marker.set_time": "Establecer hora...",
	"uv_editor.scale_uv": "Reescalar UV",
	"action.preview_scene": "Escenario",
	"action.preview_scene.desc": "Cambia el escenario del modelo",
	"preview_scene.minecraft_overworld": "Supramundo",
	"preview_scene.minecraft_nether": "Inframundo",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Invertir Eje Y",
	"preview_scene.studio": "Estudio",
	"format.image": "Imagen",
	"modifier_actions.set_copy_source": "Establecer Fuente de Copia",
	"message.load_images.title": "Cargar Imágenes",
	"message.load_images.edit_image": "Editar Imagen",
	"dialog.add_primitive.align_edges": "Alinear Bordes",
	"dialog.flip_animation.show_in_timeline": "Muestra todos los huesos modificados en la línea de tiempo",
	"settings.default_cube_size": "Tamaño del Cubo",
	"settings.default_cube_size.desc": "Cambia el tamaño por defecto del cubo al crear un nuevo cubo",
	"settings.uniform_keyframe": "Re-escalar Fotogramas Uniformemente",
	"settings.uniform_keyframe.desc": "Establece los fotogramas clave a re-escalado uniforme por defecto",
	"settings.nearest_rectangle_select": "Selección de rectángulo: Borde mas cercano",
	"settings.nearest_rectangle_select.desc": "Ajusta las selecciones rectangulares al borde del píxel más cercano, como en GIMP, en lugar de píxeles completos.",
	"settings.pick_color_opacity": "Seleccionar Opacidad del Color",
	"settings.pick_color_opacity.desc": "Seleccione la opacidad del color con el Selector de Color y configúrela como opacidad del pincel",
	"settings.paint_with_stylus_only": "Pintar con Lápiz",
	"settings.paint_with_stylus_only.desc": "Usa solo el lápiz para pintar, guarda el mouse o entrada táctil para la navegación",
	"action.copy_brush_mode": "Modo de Pincel de Copia",
	"action.copy_brush_mode.copy": "Copia",
	"action.copy_brush_mode.pattern": "Patrón",
	"action.copy_brush_mode.sample": "Ejemplo",
	"action.brush_shape": "Forma del Pincel",
	"action.brush_shape.square": "Cuadrado",
	"action.brush_shape.circle": "Circulo",
	"action.blend_mode": "Modo de Combinación",
	"action.blend_mode.default": "Por Defecto",
	"action.blend_mode.set_opacity": "Establecer Opacidad",
	"action.blend_mode.color": "Color",
	"action.blend_mode.behind": "Por Detrás",
	"action.blend_mode.multiply": "Multiplicar",
	"action.blend_mode.divide": "Dividir",
	"action.blend_mode.add": "Añadir",
	"action.blend_mode.subtract": "Restar",
	"action.blend_mode.screen": "Pantalla",
	"action.blend_mode.overlay": "Cubierta",
	"action.blend_mode.hard_light": "Luz Intensa",
	"action.blend_mode.difference": "Diferencia",
	"action.copy_brush": "Pincel de Copia",
	"action.copy_brush.desc": "Pincel para clonar partes de tu textura o dibujar patrones",
	"action.validator_window": "Ver Problemas del Modelo...",
	"action.validator_window.desc": "Abre el validador, que lista los problemas con el modelo actual.",
	"action.cancel_gif": "Cancelar Grabación",
	"menu.text_edit.copy_vector": "Copiar Vector",
	"menu.brush_presets.dialog": "Pinceles Por Defecto...",
	"menu.brush_presets.pixel_brush": "Pincel de Pixel",
	"menu.brush_presets.smooth_brush": "Pincel Suave",
	"menu.texture.edit_in_blockbench": "Editar en Blockbench",
	"menu.mirror_painting.axis": "Eje",
	"menu.mirror_painting.axis.desc": "Selecciona el eje en el que los trazos de pintura se invierten",
	"menu.mirror_painting.global": "Simetría Global",
	"menu.mirror_painting.global.desc": "Activa la inversión de pintura en el espacio global del modelo",
	"menu.mirror_painting.local": "Simetría Local",
	"menu.mirror_painting.local.desc": "Activa la inversión de pintura en el espacio local de cada elemento",
	"menu.mirror_painting.texture_frames": "Fotogramas de Texturas Animadas",
	"menu.mirror_painting.texture_frames.desc": "Invierte los trazos de pintura a cada fotograma de texturas animadas",
	"format.bedrock_block.info.size_limit": "El tamaño total de un bloque está limitado a 30 píxeles en todas sus dimensiones. Este límite puede estar descentrado hasta 7 píxeles en cualquier dirección desde el centro del bloque.",
	"format.bedrock_block.info.textures": "Se pueden aplicar múltiples texturas a diferentes cubos en Blockbench, pero requieren una configuración adicional en el paquete de comportamiento para que funcionen correctamente en el juego.",
	"format.image.desc": "Editar imágenes en el editor de imágenes 2D",
	"generic.delete_all": "Eliminar todo",
	"message.child_model_only.open": "Abrir Padre",
	"message.child_model_only.open_with_textures": "Abrir Padre y Adoptar Texturas",
	"dialog.project.credit": "Credito",
	"dialog.convert_project.create_copy": "Crear copia",
	"dialog.texture.frame_time": "Tiempo de fotograma",
	"dialog.texture.frame_time.desc": "Establece la duración de cada fotograma, en ticks. Cada tick equivale a 1/20 de segundo.",
	"dialog.texture.frame_interpolate": "Interpolar",
	"dialog.texture.frame_interpolate.desc": "Interpolar entre fotogramas de animación mediante fundido cruzado al siguiente fotograma.",
	"dialog.texture.frame_order_type": "Modo de Bucle",
	"dialog.texture.frame_order_type.loop": "Bucle",
	"dialog.texture.frame_order_type.backwards": "Bucle en Reversa",
	"dialog.texture.frame_order_type.back_and_forth": "Ida y Vuelta",
	"dialog.texture.frame_order_type.custom": "Orden Personalizado",
	"dialog.texture.frame_order": "Orden de Fotogramas",
	"dialog.texture.frame_order.desc": "Establezca un orden de fotogramas personalizado enumerando los índices de fotogramas en un nuevo orden. Los índices de fotogramas comienzan en 0 con el primer fotograma.",
	"dialog.select.mode": "Modo",
	"dialog.select.mode.new": "Nueva Selección",
	"dialog.select.mode.add": "Añadir a la Selección",
	"dialog.select.mode.remove": "Eliminar de la Selección",
	"dialog.select.mode.in_selection": "Seleccionar solo de Seleccionados",
	"dialog.predicate_overrides.model": "Modelo",
	"dialog.predicate_overrides.predicates": "Predicados",
	"dialog.predicate_overrides.variants": "Variantes",
	"dialog.predicate_overrides.start_value": "Inicio",
	"dialog.predicate_overrides.add_override": "Agregar Anulación",
	"dialog.predicate_overrides.add_predicate": "Añadir Predicado",
	"dialog.predicate_overrides.generate_overrides": "Generar Anulaciones",
	"dialog.predicate_overrides.confirm_delete": "¿Estás seguro de que quieres eliminar todas las anulaciones?",
	"dialog.predicate_overrides.predicate.angle": "Angulo de la brújula",
	"dialog.predicate_overrides.predicate.blocking": "Esta bloqueando",
	"dialog.predicate_overrides.predicate.broken": "Esta roto",
	"dialog.predicate_overrides.predicate.cast": "Está lanzada",
	"dialog.predicate_overrides.predicate.cooldown": "Enfriamiento",
	"dialog.predicate_overrides.predicate.damage": "Daño",
	"dialog.predicate_overrides.predicate.damaged": "Esta dañado",
	"dialog.predicate_overrides.predicate.lefthanded": "Es zurdo",
	"dialog.predicate_overrides.predicate.pull": "Cantidad de Carga",
	"dialog.predicate_overrides.predicate.pulling": "Está Cargando",
	"dialog.predicate_overrides.predicate.charged": "Esta cargado",
	"dialog.predicate_overrides.predicate.firework": "Tiene cohete",
	"dialog.predicate_overrides.predicate.throwing": "Listo para Lanzar",
	"dialog.predicate_overrides.predicate.time": "Hora del Día",
	"dialog.predicate_overrides.predicate.custom_model_data": "Datos de Modelo Personalizado",
	"dialog.predicate_overrides.predicate.level": "Nivel de Luz",
	"dialog.predicate_overrides.predicate.filled": "Nivel de Llenado del Saco",
	"dialog.predicate_overrides.predicate.tooting": "Tocando",
	"settings.model_export_scale": "Escala de Exportación del Modelo",
	"settings.model_export_scale.desc": "Factor por el que se reduce la escala de los modelos glTF, DAE y FBX exportados. El valor por defecto es 16, lo que convierte 16 unidades de Blockbench en 1 metro al exportar.",
	"action.export_fbx": "Exportar Modelo FBX",
	"action.export_fbx.desc": "Exporta el modelo y las animaciones como archivo FBX para usarlo en otras aplicaciones 3D y motores de juegos",
	"action.center_lateral": "Centro lateral",
	"action.center_lateral.desc": "Centra los elementos seleccionados en los ejes X y Z",
	"action.adjust_opacity": "Ajustar opacidad",
	"action.adjust_opacity.desc": "Ajusta la opacidad de la textura seleccionada",
	"action.rotate_texture_cw": "Rotar en sentido del reloj",
	"action.rotate_texture_ccw": "Rotar en sentido contra reloj",
	"action.predicate_overrides": "Editar Anulaciones de Predicado...",
	"action.predicate_overrides.desc": "Seleccione modelos para anular este modelo en función de las condiciones seleccionadas",
	"action.auto_set_cullfaces": "Establecer Ocultación Automática de Caras",
	"action.auto_set_cullfaces.desc": "Generar automáticamente la ocultación de caras para esconder aquellas caras que estén cubiertas por un bloque vecino.",
	"menu.texture.edit_externally": "Editar externamente",
	"menu.mirror_painting.texture": "Simetría del editor 2D",
	"menu.mirror_painting.texture.desc": "Activar el pintado reflejado en el espacio 2D en la imagen o textura",
	"menu.animator.rotation_global": "Rotar en el Espacio Global",
	"uv_editor.face_properties": "Propiedades de la cara",
	"uv_editor.face_properties.material_instance": "Instancia material",
	"uv_editor.tint.info": "El tinte se puede habilitar en una cara para indicar a Minecraft que la pinte. En la versión vanilla, el tinte solo se puede utilizar en bloques específicos, como hojas y polvo de redstone, y solo puede tener un valor de 0.",
	"uv_editor.cullface.info": "Habilitar la opción de ocultar caras, indica a una cara de un bloque que no se renderice si se coloca otro bloque completo junto a ella en la dirección especificada en tu mundo de Minecraft. Esto puede utilizarse para optimizar el rendimiento.",
	"uv_editor.material_instance.info": "Las instancias de materiales pueden configurarse con un nombre definido por el usuario. Dicho nombre puede utilizarse en el archivo JSON del bloque en el paquete de comportamiento, para asignar una textura y un material específicos a la cara.",
	"display.reference.frame_invisible": "Marco de Objeto (invisible)",
	"data.settings_profile": "Perfil",
	"message.display_skin.invalid_name": "No se encuentra ninguna cuenta de Minecraft con el nombre \"%0\".",
	"dialog.load_plugins_from_query.title": "Cargar Plugins",
	"dialog.load_plugins_from_query.text": "Has utilizado un enlace que requiere la instalación de plugins. ¿Deseas instalarlos?",
	"dialog.select_model.title": "Seleccionar Modelo",
	"dialog.select_model.bones": "Huesos",
	"dialog.select_model.cubes": "Cubos",
	"dialog.settings.create_profile": "Crear Perfil...",
	"settings_profile.confirm_delete": "¿Seguro que quieres eliminar este perfil de configuración?",
	"settings_profile.condition.type.selectable": "Seleccionable Manualmente",
	"settings.interface_mode": "Modo UI",
	"settings.interface_mode.desc": "Modo de Interfaz",
	"settings.interface_mode.auto": "Automático",
	"settings.interface_mode.desktop": "Escritorio",
	"settings.interface_mode.mobile": "Móvil",
	"settings.paint_through_transparency": "Pintar a Través de Transparencia",
	"settings.paint_through_transparency.desc": "Pinta a través de píxeles transparentes cuando la opción Bloquear Canal Alfa esté activada",
	"action.tab_overview": "Vista General de las Pestañas",
	"action.tab_overview.desc": "Vea todas las pestañas abiertas en una cuadrícula y acceda a la que desee",
	"action.slider_color_red": "Color Rojo",
	"action.slider_color_green": "Color Verde",
	"action.slider_color_blue": "Color Azul",
	"action.add_animation_controller": "Añadir Controlador de Animación",
	"action.add_animation_controller.desc": "Crea un controlador de animación en blanco",
	"action.animation_controller_preview_mode": "Vista Previa del Controlador",
	"action.animation_controller_preview_mode.paused": "Pausado",
	"action.animation_controller_preview_mode.manual": "Vista Previa Manual",
	"action.animation_controller_preview_mode.play": "Auto Reproducción",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Mango de enlace Bézier",
	"action.keyframe_bezier_linked.desc": "Conecta el mango Bézier del fotograma clave derecho e izquierdo",
	"action.reset_keyframe_handles": "Restablecer Manejadores de Fotogramas Clave",
	"action.reset_keyframe_handles.desc": "Reinicia el mango Bézier de los fotogramas clave seleccionados",
	"action.looped_animation_playback": "Reproducción en Bucle",
	"action.looped_animation_playback.desc": "Previsualizar animaciones en un bucle infinito",
	"timeline.bind_to_actor": "Unir al actor",
	"animation_controllers.select_preset": "Selecciona un Ajuste Preestablecido del Controlador...",
	"animation_controllers.state.animations": "Animaciones",
	"animation_controllers.state.particles": "Partículas",
	"animation_controllers.state.sounds": "Sonidos",
	"animation_controllers.state.on_entry": "En Entrada",
	"animation_controllers.state.on_exit": "En Salida",
	"animation_controllers.state.transitions": "Transiciones",
	"animation_controllers.state.condition": "Condición",
	"animation_controllers.state.blend_transition": "Tiempo de combinación",
	"animation_controllers.state.shortest_path": "Combinación por la ruta más corta",
	"animation_controllers.state.edit_transition": "Editar Transición",
	"menu.color_picker.picker_type": "Tipo de Selector",
	"menu.color_picker.picker_type.square": "Cuadrado",
	"menu.color_picker.picker_type.wheel": "Rueda",
	"menu.color_picker.slider_mode": "Modo Deslizante",
	"menu.color_picker.slider_mode.hsv": "Tono, Saturación, Valor",
	"menu.color_picker.slider_mode.rgb": "Rojo, Verde, Azul",
	"menu.texture.render_mode.additive": "Aditivo",
	"panel.color.picker_options": "Opciones del Selector de Color",
	"panel.animation_controllers": "Controlador de Animación",
	"display.preset.armor_stand": "Suelo (Soporte de Armadura)",
	"data.file_path": "Ruta del Archivo",
	"dialog.extrude.orientation": "Orientación",
	"dialog.extrude.orientation.upright": "Vertical",
	"dialog.extrude.orientation.flat": "Plano",
	"dialog.scale.box_uv_warning": "Al escalar un modelo UV de Caja, se puede romper el UV de tu modelo. En su lugar, intente escalar su modelo externamente o cambie al modo UV por Cara en Archivo > Proyecto.",
	"dialog.create_gif.format": "Formato",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Secuencia PNG",
	"dialog.create_gif.pixelate": "Pixelar",
	"dialog.create_gif.bg_image": "Imagen de Fondo",
	"dialog.create_gif.turn.desc": "Gira el modelo mientras grabas. Usa valores negativos para girarlo en el sentido de las agujas del reloj. Un valor de 60 corresponde a una rotación por segundo.",
	"settings_profile.condition": "Condición",
	"settings_profile.condition.type.file_path.desc": "Utilice la sintaxis de Expresiones Regulares para que coincida con la ruta del archivo del proyecto actual. Use barras diagonales para los directorios",
	"settings.only_selected_bezier_handles": "Mostrar Solo los Manejadores Bézier Seleccionados",
	"settings.only_selected_bezier_handles.desc": "Ocultar los manejadores de los fotogramas clave Bézier que no están seleccionados",
	"settings.embed_textures": "Insertar Texturas",
	"settings.embed_textures.desc": "Insertar el contenido del archivo de textura en archivos .bbmodel",
	"action.selection_mode.cluster": "Grupo",
	"dialog.copied_to_clipboard": "Copiado al portapapeles",
	"data.reference_image": "Imagen de Referencia",
	"message.delete_reference_image": "¿Está seguro de que desea eliminar esta imagen de referencia? Esta acción no se puede deshacer.",
	"message.add_reference_image.message": "Seleccione dónde cargar la imagen de referencia",
	"message.add_reference_image.project": "Añadir a este proyecto",
	"message.add_reference_image.app": "Añadir a todos los proyectos",
	"message.import_particle_texture.import": "Importar Textura de Partículas",
	"message.import_particle_texture.message": "¿Desea importar un archivo de textura para usarlo en su partícula?",
	"message.save_codec_selector.title": "Guardar Formato del Modelo",
	"message.save_codec_selector.message": "Seleccione un formato para guardar el modelo.",
	"message.save_codec_selector.project_file": "Proyecto Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Ambos",
	"message.display_skin.username": "Nombre de Usuario (Java)",
	"message.palette_locked": "La paleta está bloqueada",
	"dialog.project.default_uv_mode": "Modo UV Por Defecto",
	"dialog.project.default_uv_mode.description": "Modo UV por defecto del proyecto. El modo UV también se puede cambiar por cubo.",
	"dialog.export_options.title": "Opciones de exportación",
	"dialog.edit_texture.preview": "Vista previa",
	"dialog.proportional_editing.range": "Rango",
	"dialog.proportional_editing.falloff": "Caida",
	"dialog.proportional_editing.falloff.linear": "Lineal",
	"dialog.proportional_editing.falloff.hermite_spline": "Liso",
	"dialog.proportional_editing.falloff.constant": "Constante",
	"dialog.proportional_editing.selection": "Selección",
	"dialog.proportional_editing.selection.linear": "Distancia lineal",
	"dialog.proportional_editing.selection.connections": "Conexiones",
	"dialog.mirror_painting_texture_center.middle": "Medio",
	"dialog.mirror_painting_texture_center.custom": "Personalizar",
	"dialog.settings.reset_to_default": "Reiniciar por defecto",
	"keybindings.item.num_slider.increase": "Aumentar",
	"keybindings.item.num_slider.decrease": "Disminuir",
	"settings.always_show_splash_art": "Mostrar Siempre Arte de Bienvenida",
	"settings.always_show_splash_art.desc": "Mostrar siempre arte de bienvenida en la pantalla de inicio",
	"action.slider_palette_color": "Intercambiar paleta de color",
	"action.slider_palette_color.desc": "Ciclo entre los colores en la paleta",
	"action.proportional_editing": "Edición Proporcional",
	"action.proportional_editing.desc": "Afectar proporcionalmente los vértices adyacentes al editar partes de una malla",
	"action.limit_to_palette": "Limitar la paleta",
	"action.limit_to_palette.desc": "Limita los colores de la textura a los de la paleta cargada actualmente",
	"action.edit_reference_images": "Editar Imágenes de Referencia",
	"action.edit_reference_images.desc": "Activa el modo de imagen de referencia para agregar o editar imágenes de referencia y planos",
	"action.add_reference_image": "Agregar imagen de referencia",
	"action.reference_image_from_clipboard": "Imagen de referencia desde el portapapeles",
	"action.reference_image_list": "Imágenes de referencia",
	"action.connect_uv_faces": "Conectar caras UV",
	"action.connect_uv_faces.desc": "Conecta las caras UV seleccionadas a la última cara UV seleccionada",
	"action.merge_uv_vertices": "Fusionar vértices UV",
	"action.merge_uv_vertices.desc": "Ajusta los primeros vértices UV seleccionados a los últimos vértices UV seleccionados",
	"action.bedrock_animation_mode": "Modo animación de bedrock",
	"action.bedrock_animation_mode.desc": "Seleccionar el modo de editar animaciones para Minecraft: Edición Bedrock",
	"action.bedrock_animation_mode.entity": "Entidad",
	"action.bedrock_animation_mode.attachable_first": "Item en 1ra Persona",
	"action.bedrock_animation_mode.attachable_third": "Item en 3ra Persona",
	"timeline.amplify": "Amplificar",
	"menu.options": "Opciones...",
	"menu.palette.lock_palette": "Mirar paleta",
	"menu.uv.export": "Exportar mapeo UV",
	"menu.uv.flip_x": "Espejo X",
	"menu.uv.flip_y": "Espejo Y",
	"menu.mirror_painting.enabled": "Habilitar",
	"reference_image.position": "Posición",
	"reference_image.size": "Tamaño",
	"reference_image.rotation": "Rotación",
	"reference_image.opacity": "Opacidad",
	"reference_image.visibility": "Visibilidad",
	"reference_image.clear_mode": "Modo claro",
	"reference_image.layer": "Capa",
	"reference_image.layer.background": "Detrás del modelo",
	"reference_image.layer.viewport": "Sobre el modelo",
	"reference_image.layer.float": "Sobre la interfaz",
	"reference_image.scope": "Alcance",
	"reference_image.scope.project": "Solo este proyecto",
	"reference_image.scope.global": "Todos los proyectos",
	"reference_image.enabled_modes": "Habilitado en modos",
	"codec.common.encoding": "Codificación",
	"codec.common.armature": "Exportar los grupos como armadura",
	"codec.common.export_animations": "Exportar animaciones",
	"codec.common.embed_textures": "Incrustar texturas",
	"preview.center_camera": "Cámara central",
	"display.reference.frame_top": "Cuadro de item superior",
	"display.reference.frame_top_invisible": "Cuadro de item superior (invisible)",
	"action.proportional_editing_range": "Rango de Edición Proporcional",
	"action.proportional_editing_range.desc": "Ajustar el rango para la edición proporcional",
	"action.toggle_all_reference_images": "Ocultar/Mostrar todas las imágenes de referencia",
	"action.toggle_all_reference_images.desc": "Alterna la visibilidad de todas las imágenes de referencia a la vez",
	"action.add_animation_controller_state": "Agregar estado del controlador de animación",
	"action.add_animation_controller_state.desc": "Agregar un nuevo estado al controlador de animaciones",
	"menu.slider.round_value": "Redondear valor",
	"texture.error.too_large": "La resolución excede el máximo de %0",
	"dialog.copy_to_clipboard": "Copiar al portapapeles",
	"dialog.open_url": "Abrir URL",
	"reference_image.image": "Imagen",
	"uv_editor.rotate_uv": "Rotar UV",
	"generic.error": "Error",
	"projects.start_screen": "Pantalla de inicio",
	"message.invalid_link.message": "El modelo compartido \"%0\" que tu intentas cargar no es valido o ha expirado",
	"message.plugin_dependencies.title": "Dependencia de Plugin",
	"message.plugin_dependencies.message1": "El Plugin requiere estas dependencias:",
	"message.plugin_dependencies.message1_update": "El Plugin %0 ha sido actualizado y ahora requiere estas dependencias:",
	"message.plugin_dependencies.message2": "¿Quieres instalarlos para continuar?",
	"message.plugin_dependencies.invalid": "Desafortunadamente el Plugin no se puede instalar, tiene una dependencia invalida:",
	"message.preview_scene_load_failed": "Falló al cargar la escena previa. Revisa tu conexión a internet.",
	"dialog.convert_project.text1": "Convertir el proyecto a un formato diferente.",
	"dialog.convert_project.text2": "Use la conversión bajo su propio riesgo. Los formatos tienen diferentes características y restricciones,  por lo que, en algunos casos, rompería partes de tu proyecto.",
	"dialog.convert_project.text3": "No puedes deshacer la conversión, es por eso que por defecto se crearía una copia.",
	"dialog.unsaved_work.title": "Trabajo no guardado",
	"dialog.unsaved_work.text": "Los siguientes proyectos contienen cambios sin guardar. ¿Quieres guardarlos?",
	"dialog.unsaved_work.discard_all": "Descartar todo",
	"dialog.unsaved_work.save_all": "Guardar todo",
	"dialog.resize_texture.mode": "Modo",
	"dialog.resize_texture.mode.crop": "Recortar/Expandir",
	"dialog.resize_texture.mode.scale": "Escala",
	"dialog.plugins.is_installed": "Instalado",
	"dialog.plugins.is_disabled": "Desactivado",
	"dialog.plugins.disable": "Desactivar",
	"dialog.plugins.enable": "Activar",
	"dialog.plugins.dependencies": "Depende de:",
	"dialog.view_backups.open_folder": "Abrir Carpeta",
	"dialog.share_model.reference_images": "Incluye imágenes de referencia",
	"dialog.share_model.too_large": "Falló al cargar: el modelo es demasiado grande",
	"dialog.share_model.too_large_references": "Falló al cargar: el modelo es demasiado grande. Inténtalo sin imágenes de referencia.",
	"settings.stretch_linked": "Estiramiento de Enlaces",
	"settings.stretch_linked.desc": "Estira el cubo en todas las direcciones con el mismo valor",
	"settings.grids": "Mostrar Cuadrículas",
	"settings.grids.desc": "Mostrar u ocultar todas las cuadrículas 3D",
	"settings.double_click_switch_tools": "Cambiar Herramientas con Doble Click",
	"settings.double_click_switch_tools.desc": "Haga doble click en la ventana gráfica para cambiar entre herramientas",
	"settings.outlines_in_paint_mode": "Selección de Contornos en Modo Pintura",
	"settings.outlines_in_paint_mode.desc": "Mostrar contornos de los elementos seleccionados mientras estás en modo pintura",
	"settings.json_indentation": "Sangría JSON",
	"settings.json_indentation.desc": "Estilo de sangría para archivos JSON exportados",
	"settings.json_indentation.tabs": "Tabulaciones",
	"settings.json_indentation.spaces_4": "Espacios: 4",
	"settings.json_indentation.spaces_2": "Espacios: 2",
	"action.slider_stretch": "Estirar",
	"action.slider_stretch.desc": "Estira los cubos multiplicativamente en el eje %0 sin cambiar el UV",
	"action.view_backups": "Ver Copias de Seguridad",
	"action.view_backups.desc": "Explora la lista de copias de seguridad de proyectos guardadas automáticamente",
	"action.search_outliner": "Buscador en el Esquema",
	"action.search_outliner.desc": "Buscar nombres de elementos específicos en el esquema",
	"action.mirror_modeling": "Modelado de espejo",
	"action.mirror_modeling.desc": "Habilita el modelado de espejo en el eje X. Todos los cambios que realice en la ventana se reflejarán en el otro lado, a menos que se deshabiliten específicamente en el elemento.",
	"action.allow_element_mirror_modeling": "Permitir modelado de espejo",
	"action.allow_element_mirror_modeling.desc": "Elije si los elementos seleccionados puedan verse afectados por el modelado de espejo",
	"action.switch_face_crease": "Cambiar el Pliegue de Cara",
	"action.switch_face_crease.desc": "Cambia la dirección en la que se pliega el cuadrilátero en el medio",
	"action.clear_unused_texture_space": "Limpiar el espacio de textura sin usar",
	"action.clear_unused_texture_space.desc": "Limpiar las partes de la textura que no están asignadas mediante rayos UV a ningún elemento",
	"action.split_screen": "Pantalla Dividida",
	"action.split_screen.desc": "Selecciona un modo de pantalla dividida para la ventana grafica",
	"action.split_screen.single": "Simple",
	"action.split_screen.double_horizontal": "Doble Horizontal",
	"action.split_screen.double_vertical": "Doble Vertical",
	"action.split_screen.quad": "Cuádruple",
	"action.split_screen.triple_left": "Triple Izquierda",
	"action.split_screen.triple_right": "Triple Derecha",
	"action.split_screen.triple_top": "Triple Superior",
	"action.split_screen.triple_bottom": "Triple Inferior",
	"action.uv_project_from_view": "Proyecto UV desde la vista",
	"action.uv_project_from_view.desc": "Genera automáticamente UV para las caras seleccionadas desde la perspectiva de la vista 3D",
	"action.graph_editor_other_graphs": "Mostrar otros gráficos",
	"action.graph_editor_other_graphs.desc": "Se muestran los gráficos de los ejes que no están seleccionados",
	"action.graph_editor_include_other_graphs": "Incluir otros gráficos",
	"action.graph_editor_include_other_graphs.desc": "El editor de gráficos incluye gráficos que no están seleccionados en la vista",
	"action.set_ik_source": "Establecer CI de raíz",
	"action.set_ik_source.desc": "Seleccionar el hueso raíz de la cadena que debe de ser movido por este objeto nulo a través de la cinemática inversa",
	"edit.loop_cut.cuts": "Cortes",
	"panel.element.stretch": "Estirar",
	"preview_scene.minecraft_plains": "Llanuras",
	"preview_scene.minecraft_cherry_grove": "Árboles de cerezo",
	"preview_scene.minecraft_snowy_tundra": "Tundra nevada",
	"preview_scene.minecraft_sunset": "Atardecer",
	"preview_scene.minecraft_night": "Noche",
	"preview_scene.minecraft_desert": "Desierto",
	"preview_scene.minecraft_underwater": "Bajo el agua",
	"preview_scene.minecraft_coral_reef": "Arrecifes de coral",
	"preview_scene.minecraft_lush_cave": "Cueva exuberante",
	"preview_scene.minecraft_deep_dark": "Profundidad oscura",
	"generic.navigate_forward": "Adelante",
	"generic.navigate_back": "Atrás",
	"action.element_render_order": "Orden de Renderizado de Elementos Transparentes",
	"action.element_render_order.default": "Automático",
	"action.element_render_order.behind": "Detrás",
	"action.element_render_order.in_front": "Delante",
	"message.installing_update.title": "Actualización disponible",
	"message.installing_update.message": "Una nueva versión está listo para ser instalado. Después de cerrar la app, por favor espero %0 segundos antes de abrir Blockbench de nuevo o apaga el ordenador para que se instale la actualización.",
	"settings.brush_cursor_2d": "Cursor de Pincel 2D",
	"settings.brush_cursor_2d.desc": "Mostrar un contorno alrededor del pincel en el espacio de trabajo 2D",
	"settings.brush_cursor_3d": "Cursor de Pincel 3D",
	"settings.brush_cursor_3d.desc": "Mostrar un contorno alrededor del pincel en el espacio de trabajo 3D",
	"settings.cdn_mirror": "Usar CDN Espejo",
	"settings.cdn_mirror.desc": "Utilice el espejo CDN para descargar complementos (plugins). El espejo recibe las actualizaciones más rápidamente y funciona en algunas regiones en las que por defecto no funciona.",
	"data.layer": "Capa",
	"data.panel": "Panel",
	"generic.confirm_delete": "¿Estás seguro que quieres eliminar esto?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Escalado libre",
	"message.texture_refresh_conflict.title": "Conflicto de versiones de texturas",
	"message.texture_refresh_conflict.message": "El archivo de textura podría contener cambios que entren en conflicto con la versión de Blockbench",
	"message.texture_refresh_conflict.keep_ours": "Mantener la versión de Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "Cargar archivo y descartar todos los cambios y capas en Blockbench",
	"message.group_required_to_animate": "No puedes animar este tipo de elemento. Crea un grupo o armadura para animarlo.",
	"dialog.texture.uv_size": "Tamaño UV",
	"dialog.advanced_screenshot.angle_preset": "Preajuste del ángulo",
	"dialog.advanced_screenshot.resolution": "Resolución",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom para ajustar",
	"dialog.advanced_screenshot.zoom": "Zoom / Longitud focal",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Apagado",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Muestreo multiple",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Super muestreo",
	"dialog.advanced_screenshot.show_gizmos": "Mostrar edición de Gizmos",
	"dialog.advanced_screenshot.shading": "Sombreado",
	"settings.auto_keyframe": "Fotograma Clave Automático",
	"settings.auto_keyframe.desc": "Crear automáticamente un fotograma clave con valores por defecto al inicio de la línea de tiempo al transformar el hueso en un punto posterior",
	"settings.modded_entity_integer_size": "Tamaño Entero de Entidad Modificada",
	"settings.modded_entity_integer_size.desc": "Limite el tamaño de los cubos en el formato de Entidad Modificada a enteros. Si bien algunas versiones admiten números flotantes, los enteros son mucho más fáciles de mapear con UV.",
	"category.layers": "Capas",
	"keybind.paint_secondary_color": "Pintar con el color secundario",
	"action.selection_tool_operation_mode": "Modo de operación de selección",
	"action.selection_tool_operation_mode.create": "Nueva selección",
	"action.selection_tool_operation_mode.add": "Agregar a la selección",
	"action.selection_tool_operation_mode.subtract": "Sustraer de la selección",
	"action.selection_tool_operation_mode.intersect": "Intersectar",
	"action.pixel_perfect_drawing": "Dibujo de pixel perfecto",
	"action.pixel_perfect_drawing.desc": "Dibujar líneas de pixel-art liso sin píxeles dobles en las curvas",
	"action.selection_tool": "Herramienta de selección",
	"action.selection_tool.desc": "Selecciona partes de la imagen",
	"action.selection_tool.rectangle": "Rectángulo",
	"action.selection_tool.ellipse": "Elipse",
	"action.selection_tool.lasso": "Selección de lazo",
	"action.selection_tool.wand": "Varita mágica",
	"action.selection_tool.color": "Mismo color",
	"action.move_layer_tool": "Mover Capa",
	"action.move_layer_tool.desc": "Mover la capa o selección actual",
	"action.export_modded_animations": "Exportar animaciones de entidades modificadas",
	"action.export_modded_animations.desc": "Exporta animaciones para un modelo de entidad modificada de Minecraft Edición java",
	"action.swap_colors": "Intercambiar colores",
	"action.swap_colors.desc": "Intercambiar el color principal con el color secundario",
	"action.apply_mesh_rotation": "Aplicar Rotación",
	"action.apply_mesh_rotation.desc": "Restablezca la rotación del elemento de la malla y aplíquela a la geometría en su lugar",
	"action.flip_texture_x.desc": "Voltear la textura o capa horizontalmente",
	"action.flip_texture_y.desc": "Voltear la textura o capa verticalmente",
	"action.rotate_texture_cw.desc": "Rotar la textura o capa en sentido horario",
	"action.rotate_texture_ccw.desc": "Rotar la textura o capa en sentido antihorario",
	"action.crop_texture_to_selection": "Recortar textura a la selección",
	"action.create_empty_layer": "Crear una capa vacía",
	"action.enable_texture_layers": "Habilitar capas",
	"action.disable_texture_layers": "Deshabilitar capas",
	"action.layer_opacity": "Opacidad de la capa",
	"action.layer_to_texture_size": "Expandir capa al tamaño de la textura",
	"action.layer_to_texture_size.desc": "Expande la capa al tamaño de la textura",
	"action.merge_layer_down": "Fusionar abajo",
	"action.merge_layer_down.desc": "Se Fusiona con la capa de abajo",
	"action.advanced_screenshot": "Captura de pantalla avanzada",
	"action.advanced_screenshot.desc": "Toma una captura de pantalla al modelo con opciones avanzadas",
	"action.bake_ik_animation": "Cinemática inversa de horneado",
	"action.bake_ik_animation.desc": "Hornea las rotaciones aplicadas por cinemáticas inversas en la animación seleccionada",
	"action.save_animation_preset": "Guarda preajuste de animación",
	"action.save_animation_preset.desc": "Guarda los fotogramas clave como un ajuste preestablecido de animación",
	"action.animation_onion_skin": "Animación de skin Onion",
	"action.animation_onion_skin.desc": "Muestra una vista de estructura alámbrica de un cuadro diferente en la animación como referencia",
	"action.apply_animation_preset": "Aplicar ajuste preestablecido de animación",
	"action.apply_animation_preset.desc": "Selecciona desde una lista de ajustes preestablecidos de animación y lo aplica al hueso seleccionado",
	"menu.brush_presets.pixel_perfect": "Pincel de píxeles perfectos",
	"panel.layers": "Capas",
	"uv_editor.copy_paste_tool.to_layer": "A la nueva capa",
	"format.image.new": "Crear nueva imagen",
	"format.image.info.summary": "El editor de imagen 2D te permite crear y editar imágenes y pixelart directamente en Blockbench, sin la necesidad de un editor de imagen externo. ¡Edita imágenes, modifica texturas, o crea tu propio pixelart!",
	"settings.move_with_selection_tool": "Usar la Herramienta de Selección para Mover Selecciones",
	"settings.move_with_selection_tool.desc": "Permite que la Herramienta de Selección mueva directamente las selecciones, sin tener que cambiar a la herramienta Mover Capa",
	"settings.final_newline": "Nueva Línea Final",
	"settings.final_newline.desc": "Insertar un carácter de nueva línea al final de los archivos exportados",
	"action.crop_layer_to_selection": "Capa de recorte a la selección",
	"action.edit_mode_uv_overlay.desc": "Muestra el mapa UV como una superposición en el modo edición",
	"menu.image": "Imagen",
	"menu.texture.discard_changes": "Descartar cambios",
	"menu.texture.discard_changes.desc": "Descartar todos los cambios no guardados y cargar la última versión del archivo",
	"panel.textures.images": "Imágenes",
	"dialog.advanced": "Avanzado",
	"dialog.recommended_option": "Recomendado",
	"modifier_actions.snap_to_center": "Ajustar centro",
	"modifier_actions.snap_to_pixels": "Ajustar pixeles",
	"message.invalid_format.install_plugin": "Instalar plugin '%0'",
	"message.plugin_deprecated.message": "¿Estás seguro que quieres instalar este plugin obsoleto?",
	"message.plugin_deprecated.install_anyway": "Instalar de todas maneras",
	"message.image_editor.not_found": "No se puede encontrar el editor de imágenes seleccionado. Por favor seleccione otra opción.",
	"message.knife_tool.confirm": "Presiona %0 o haga clic aquí para aplicar la herramienta de cuchillo",
	"message.knife_tool.skipped_face": "No se puede cortar entre caras diferentes. ¡Incluya las aristas o vértices entre ellas!",
	"message.optimize_animation.keyframes_removed": "Se eliminaron %0 fotogramas claves redundantes",
	"message.optimize_animation.nothing_to_optimize": "¡No se encontró nada para optimizar!",
	"message.duplicate_bone_copy_animation.title": "Copiar animación",
	"message.duplicate_bone_copy_animation.message": "El hueso duplicado es animado en %0 animaciones. ¿Quieres copiar los fotogramas clave al nuevo hueso?",
	"message.auto_fix_mesh_edit.title": "Arreglar automáticamente",
	"message.auto_fix_mesh_edit.revert": "Revertir edición",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Ciertos vértices han sido movidos al mismo lugar. ¿Cómo te gustaría proceder?",
	"message.auto_fix_mesh_edit.concave_quads": "Una o más caras del cuadrante ahora son cóncavas, lo que puede causar problemas en el mapeo UV y el renderizado. Blockbench puede solucionarlo automáticamente por ti:",
	"message.auto_fix_mesh_edit.merge_vertices": "Fusionar vértices",
	"message.auto_fix_mesh_edit.split_quads": "Cuádriceps divididos",
	"message.load_images.add_image": "Agregar imagen",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Desplazamiento",
	"dialog.animated_texture_editor.code_reference": "Código de referencia",
	"dialog.animated_texture_editor.code_reference.about": "Este código para implementar a la animación de textura se generó como referencia y no funciona necesariamente sin modificaciones. Consulta la documentación para obtener más información.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentación",
	"dialog.animated_texture_editor.reframe": "Recuadro",
	"dialog.animated_texture_editor.stride": "Tamaño del cuadro",
	"dialog.animated_texture_editor.frames": "Número de cuadros",
	"dialog.animated_texture_editor.add_frame": "Agregar cuadro",
	"dialog.animated_texture_editor.resize_frames": "Cambiar tamaño de los cuadros...",
	"dialog.animated_texture_editor.apply": "Aplicar",
	"dialog.add_primitive.edge_size": "Tamaño del borde",
	"dialog.change_animation_speed.speed": "Velocidad",
	"dialog.change_animation_speed.adjust_snapping": "Ajustar Snapping",
	"dialog.optimize_animation.selection": "Selección",
	"dialog.optimize_animation.selection.selected_keyframes": "Seleccionar Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Animación seleccionada",
	"dialog.optimize_animation.selection.all_animations": "Todas las animaciones",
	"dialog.optimize_animation.thresholds": "Límites de valores",
	"dialog.import_obj.obj": "Archivo OBJ",
	"dialog.import_obj.mtl": "Archivo MTL",
	"dialog.import_obj.scale": "Escalar",
	"layout.thumbnail": "CSS Personalizado para Miniaturas",
	"settings.pixel_grid": "Cuadrícula de Píxeles",
	"settings.pixel_grid.desc": "Mostrar la cuadrícula de píxeles de textura en los elementos en el modo de edición",
	"settings.image_editor_grid_size": "Tamaño de Cuadrícula del Editor de Imágenes",
	"settings.image_editor_grid_size.desc": "Tamaño de la cuadrícula grande en el editor de imágenes en 2D",
	"settings.ground_plane_double_side": "Plano de Suelo de Doble Cara",
	"settings.ground_plane_double_side.desc": "Hacer que el plano de suelo sea visible desde abajo",
	"settings.optifine_save_default_texture": "Optifine JEM: Exportar textura seleccionada",
	"settings.optifine_save_default_texture.desc": "Exportar la textura seleccionada como la textura por defecto del modelo",
	"action.slider_color_select_threshold": "Selecciona el límite de color",
	"action.slider_color_select_threshold.desc": "Qué tan cerca debe estar el color de un píxel vecino para ser seleccionado por color o selección de varita",
	"action.stretch_tool": "Estirar",
	"action.stretch_tool.desc": "Herramienta para seleccionar y estirar elementos",
	"action.knife_tool": "Herramienta de cuchillo",
	"action.knife_tool.desc": "Herramienta para cortar caras de malla en piezas más pequeñas",
	"action.duplicate_project": "Duplicar proyecto",
	"action.duplicate_project.desc": "Crea una copia del proyecto abierto",
	"action.transform_space.parent": "Padre",
	"action.transform_pivot_space": "Espacio de transformación del pivote",
	"action.solidify_mesh_selection": "Solidificar Caras",
	"action.solidify_mesh_selection.desc": "Solidifica las caras seleccionadas de la malla",
	"action.animated_texture_editor": "Editor Flipbook",
	"action.animated_texture_editor.desc": "Edita la animación Flipbook de la textura seleccionada",
	"action.center_individual_pivots": "Pivotes individuales centrales",
	"action.center_individual_pivots.desc": "Establece el punto del pivote de cada elemento seleccionado en su centro",
	"action.uv_cycle": "Ciclo UV",
	"action.uv_cycle.desc": "Recorre el orden de los vértices UV sin cambiar las posiciones UV",
	"action.uv_cycle_invert": "Ciclo de UV invertido",
	"action.uv_cycle_invert.desc": "Invierte el orden de los vértices UV sin cambiar las posiciones UV",
	"action.slider_animation_controller_speed": "Velocidad de reproducción del controlador",
	"action.slider_animation_controller_speed.desc": "La velocidad de reproducción de los controladores de animación en porcentaje",
	"action.optimize_animation": "Optimizar animación",
	"action.optimize_animation.desc": "Optimiza la animación actual y reduce la cantidad de fotogramas clave",
	"action.change_animation_speed": "Cambiar velocidad de la animación",
	"action.change_animation_speed.desc": "Cambia la velocidad de la animación seleccionada",
	"timeline.select_particle_file": "Seleccionar archivo de partícula",
	"timeline.select_sound_file": "Seleccionar archivo de sonido",
	"menu.cube.texture.default": "Por defecto",
	"menu.texture.particle.clear": "Dejar de usar partículas",
	"menu.texture.use_as_default": "Establecer como predeterminado",
	"menu.texture.use_as_default.clear": "Desasignar como predeterminado",
	"menu.toolbar.overflow": "Desbordamiento de la barra de herramientas",
	"edit.solidify_mesh_selection.thickness": "Espesor",
	"reference_image.sync_to_timeline": "Sincronizar con la línea del tiempo",
	"reference_image.toggle_playback": "Reproducir/Pausar",
	"dialog.add_primitive.shape.beveled_cuboid": "Cuboide biselado",
	"dialog.ignore_all": "Ignorar todo",
	"data.texture_group": "Grupo de texturas",
	"data.animation": "Animación",
	"generic.on": "Encendido",
	"generic.off": "Apagado",
	"format.free.info.3d_printing": "Impresión 3D",
	"message.invalid_file.merge_conflict": "El archivo contiene conflictos de fusión Git sin resolver.",
	"dialog.expand_texture_selection.radius": "Cantidad",
	"dialog.expand_texture_selection.corner": "Forma de la esquina",
	"dialog.expand_texture_selection.corner.round": "Redondo",
	"dialog.expand_texture_selection.corner.square": "Cuadrado",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Fusionarse en",
	"keybindings.variation_conflict": "La variación entra en conflicto con la combinación de teclas principal",
	"settings.recovery_save_interval": "Intervalo de Guardado del Punto de Recuperación",
	"settings.recovery_save_interval.desc": "Blockbench guarda periódicamente el proyecto abierto en segundo plano para poder recuperarlo en caso de un fallo del sistema. Establezca el intervalo en segundos. Establezca el valor en 0 para desactivar el guardado.",
	"settings.save_view_per_tab": "Guardar Vista por Pestaña",
	"settings.save_view_per_tab.desc": "Guarda el ángulo de visión actual para cada pestaña por separado",
	"settings.inherit_parent_color": "Heredar Color del Padre",
	"settings.inherit_parent_color.desc": "Establece el color del marcador de un elemento recién creado al color del padre en lugar de un color aleatorio",
	"keybind.preview_select.multi_select": "Selección multiple",
	"keybind.preview_select.group_select": "Selección de grupo",
	"keybind.preview_select.loop_select": "Selección de bucle",
	"action.fill_mode.selection": "Selección",
	"action.fill_mode.selected_elements": "Elementos seleccionados",
	"action.image_tiled_view": "Vista en mosaico",
	"action.image_tiled_view.description": "Habilita la vista en mosaico en el editor 2D",
	"action.image_onion_skin_view": "Editor de imágenes Onion Skin",
	"action.image_onion_skin_view.description": "Habilita la vista de Skin Onion en el editor 2D",
	"action.expand_texture_selection": "Expandir selección de la textura",
	"action.expand_texture_selection.desc": "Expande o reduce la selección de la textura",
	"action.switch_tabs.reverse_order": "Orden inverso",
	"action.save_project_incremental": "Guardar proyecto con incremento",
	"action.save_project_incremental.desc": "Guarda el modelo actual como un archivo de proyecto con un incremento (ej: projecto_2.bbmodel)",
	"action.copy.multiple": "Copiar Todo",
	"action.copy.multiple.desc": "Copia todos los datos disponibles individualmente",
	"action.paste.multiple": "Pegar Todo",
	"action.randomize_marker_colors": "Aleatorizar Colores de Marcadores",
	"action.cube_light_emission": "Emisión de Luz",
	"action.cube_light_emission.desc": "Cambiar la emisividad de los cubos seleccionados, con un valor entre 0 y 15",
	"action.view_mode.colored_solid": "Sólido con colores marcados",
	"action.focus_on_selection.rotate_only": "Solo rotación",
	"action.create_texture_group": "Crear grupo de texturas",
	"action.create_texture_group.desc": "Crear un grupo para tus texturas",
	"action.uv_maximize.all_faces": "Afecta todas las caras",
	"action.retarget_animators": "Reorientar animaciones",
	"action.retarget_animators.desc": "Selecciona que animador se dirige a que hueso o elemento",
	"action.merge_animation": "Mezclar animación",
	"action.merge_animation.desc": "Mezclar la animación en otra animación",
	"action.add_keyframe.reset_values": "Con los valores por defecto",
	"action.set_timeline_range_start": "Establecer el inicio del rango de la línea de tiempo",
	"action.set_timeline_range_start.desc": "Establece el punto de inicio para un rango de reproducción personalizado en la línea de tiempo de la animación",
	"action.set_timeline_range_end": "Establecer el final del rango de la línea de tiempo",
	"action.set_timeline_range_end.desc": "Establece el punto final para un rango de reproducción personalizado en la línea de tiempo de la animación",
	"action.disable_timeline_range": "Deshabilitar el rango de la línea de tiempo",
	"action.disable_timeline_range.desc": "Deshabilita el rango de reproducción personalizado en la línea de tiempo de la animación",
	"menu.texture_group.resolve": "Resolver",
	"menu.image_tiled_view.mirrored": "Bordes reflejados",
	"menu.image_onion_skin_view.frame": "Fotogramas",
	"menu.image_onion_skin_view.frame.last_viewed": "Fotograma anteriormente visto",
	"menu.image_onion_skin_view.frame.previous": "Fotograma previo",
	"menu.image_onion_skin_view.frame.next": "Siguiente fotograma",
	"menu.image_onion_skin_view.frame.both": "Previo + anterior",
	"menu.image_onion_skin_view.display": "Mostrar",
	"menu.image_onion_skin_view.display.pixels": "Pixeles mas pequeños",
	"menu.image_onion_skin_view.display.transparent": "Transparente",
	"menu.image_onion_skin_view.above": "Mostrar abajo",
	"menu.animation.reload": "Recargar",
	"switches.autouv.alt": "Relativo",
	"display.rotation_pivot": "Eje de rotación",
	"display.scale_pivot": "Eje de escala",
	"display.reference.fox": "Zorro",
	"display.reference.eating": "Comer",
	"preview_scene.sky": "Cielo",
	"preview_scene.space": "Espacio",
	"preview_scene.minecraft_ocean": "Oceano",
	"message.import_palette.selection_only": "Solo selección",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generar...",
	"dialog.blend_transition_edit.generate.learn_more": "Mas info y vista previa",
	"dialog.blend_transition_edit.generate.curve": "Tipo de suavidad",
	"dialog.blend_transition_edit.generate.steps": "Fotogramas clave",
	"settings.fps_limit": "Limite de FPS",
	"settings.fps_limit.desc": "Limita cuantos fotogramas por segundo Blockbench renderiza. La velocidad de fotogramas real está limitada a lo que tu dispositivo puede mostrar.",
	"settings.outliner_reveal_on_select": "Mostrar Elementos al Seleccionar",
	"settings.outliner_reveal_on_select.desc": "Mostrar elementos en el esquema cuando se seleccionan",
	"settings.java_export_pivots": "Exportar Pivotes en modelos de bloques/objetos de Java",
	"settings.java_export_pivots.desc": "Guardar puntos de pivote en modelos de bloques/objetos de Java en cubos sin rotación",
	"animation_controllers.state.blend_transition_curve": "Curva de transición de combinación",
	"menu.slider.reset_vector": "Reajustar vector",
	"dialog.blend_transition_edit.extended": "Grafico extendido",
	"message.screenshot_too_large.title": "Problema en la resolución de la captura",
	"message.screenshot_too_large.message": "La captura de pantalla no podrá renderizarse exitosamente. por favor inténtelo otra vez con una resolución mas baja o sin supersampling.",
	"message.rename_elements.numbering": "Puedes usar caracteres especiales para generar números secuenciales: % para obtener el índice del elemento dentro de su grupo, $ para obtener el índice dentro de la selección.",
	"generic.edit_externally": "Editar externamente",
	"message.settings_require_restart.title": "Reinicio Requerido",
	"message.settings_require_restart.message": "Algunas configuraciones solo se aplicarán después de reiniciar el programa.",
	"message.settings_require_restart.restart_now": "Reiniciar Ahora",
	"message.settings_require_restart.restart_later": "Reiniciar Despues",
	"message.classroom_mode.install_plugin": "No se pueden instalar complementos (plugins) en el Modo Aula",
	"dialog.collection.export_path": "Exportar ruta",
	"dialog.collection.select_all": "Seleccionar todo",
	"dialog.collection.select_none": "Seleccionar nada",
	"dialog.collection.add_with_filter": "Agregar con filtro",
	"dialog.collection.remove": "Eliminar",
	"dialog.material_config.title": "Configuración del material",
	"dialog.material_config.color_value": "Valor del color",
	"dialog.material_config.mer": "Rugosidad emisora de metal",
	"dialog.material_config.mer_value": "Valor REM",
	"dialog.material_config.depth_type": "Tipo de profundidad",
	"dialog.create_texture.disable_mirror_uv": "Deshabilitar espejo UV",
	"dialog.create_texture.disable_mirror_uv.desc": "Deshabilita la opción espejo UV en modelado de espejo para conservar UV separados por cada lado del modelo",
	"dialog.create_gif.turn.sync_to_anim_length": "Sincronizar longitud de la animación",
	"settings.category.controls": "Controles",
	"settings.classroom_mode": "Modo Aula",
	"settings.classroom_mode.desc": "Restringe funciones como la instalación de complementos (plugins) y elimina los enlaces a redes sociales.",
	"settings.antialiasing_bleed_fix": "Corregir Sangrado Anti-aliasing",
	"settings.antialiasing_bleed_fix.desc": "Corrige el sangrado de texturas al usar el suavizado de bordes (Anti-aliasing). Puede que no sea compatible con hardware antiguo.",
	"settings.tone_mapping": "Mapeo de Tonos",
	"settings.tone_mapping.desc": "Método de aproximación para mostrar un alto rango dinámico en una pantalla estándar para renderizado PBR.",
	"settings.audio_scrubbing": "Reproducción de Audio al Desplazar la Línea de Tiempo",
	"settings.audio_scrubbing.desc": "Reproduce breves fragmentos de audio mientras te desplazas por la línea de tiempo",
	"settings.viewport_rotate_speed": "Velocidad de Rotación de la Ventana Gráfica",
	"settings.viewport_rotate_speed.desc": "Sensibilidad de entrada al rotar en la Ventana Grafica",
	"settings.viewport_zoom_speed": "Velocidad de Zoom de la Ventana Gráfica",
	"settings.viewport_zoom_speed.desc": "Sensibilidad de entrada al hacer zoom en la ventana gráfica",
	"settings.editor_2d_zoom_speed": "Velocidad de Zoom del Editor 2D",
	"settings.editor_2d_zoom_speed.desc": "Sensibilidad de entrada al hacer zoom en el editor UV y de pintura 2D",
	"category.select": "Seleccionar",
	"action.vertex_snap_mode.rotate": "Rotar",
	"action.export_image": "Exportar imagen",
	"action.export_image.desc": "Exporta tu textura como un archivo de imagen",
	"action.apply_mirror_modeling": "Aplicar modelado de espejo",
	"action.apply_mirror_modeling.desc": "Aplica modelado de espejo a la selección. Todos los elementos seleccionados serán copiados y se voltearan respecto al eje X.",
	"action.create_collection": "Crear colección",
	"action.create_collection.desc": "Crea una colección a partir de la selección del esquema",
	"action.set_collection_content_to_selection": "Establecer el contenido de la colección como seleccionado",
	"action.set_collection_content_to_selection.desc": "Establece los grupos y elementos seleccionados como contenido de la colección",
	"action.add_to_collection": "Agregar a la colección seleccionada",
	"action.add_to_collection.desc": "Agrega los grupos y elementos a la colección seleccionada",
	"action.view_mode.material": "Vista previa del material",
	"action.create_material": "Crear material",
	"action.create_material.desc": "Crea un nuevo material RBF a partir de la textura seleccionada",
	"action.generate_pbr_map": "Generar mapa RBF...",
	"action.generate_pbr_map.desc": "Genera un mapa RBF (mapa de altura o metalicidad, emisividad, rugosidad) a partir de una textura existente",
	"menu.tools.main_tools": "Caja de herramientas",
	"menu.view.panels": "Paneles",
	"menu.texture.pbr_channel": "Canal RBF",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Altura",
	"menu.texture.pbr_channel.mer": "MER (Metalicidad-Emisividad-Rugosidad)",
	"menu.texture.pbr_channel.mer_subsurface": "Subsuelo MER",
	"menu.collection.export_project": "Exportar proyecto",
	"menu.collection.export_as": "Exportar como \"%0\"",
	"menu.panel.enable": "Habilitar",
	"menu.panel.move_to": "Mover a",
	"menu.panel.move_to.left_bar": "Barra lateral izquierda",
	"menu.panel.move_to.right_bar": "Barra lateral derecha",
	"menu.panel.move_to.top": "Arriba",
	"menu.panel.move_to.bottom": "Abajo",
	"menu.panel.move_to.float": "Flotar",
	"menu.panel.move_to.hidden": "Ocultar",
	"menu.panel.fold": "Colapsar",
	"menu.mirror_painting.texture_center": "Origen",
	"menu.mirror_modeling.mirror_uv": "Espejo UV",
	"menu.animation_onion_skin.frames": "Cuadros",
	"menu.animation_onion_skin.select": "Seleccionar",
	"menu.animation_onion_skin.previous": "Anterior",
	"menu.animation_onion_skin.next": "Siguiente",
	"menu.animation_onion_skin.previous_next": "Anterior + Siguiente",
	"menu.animation_onion_skin.count": "Contar",
	"menu.animation_onion_skin.interval": "Intervalo",
	"menu.animation_onion_skin_selective": "Skin Onion selectivo",
	"menu.animation_onion_skin_selective.desc": "Muestra solo la Onion skin para la parte seleccionada del modelo",
	"edit.loop_cut.unit": "Unidad",
	"edit.loop_cut.unit.size_units": "Unidades de tamaño",
	"edit.loop_cut.unit.percent": "Porcentaje",
	"edit.extrude_mesh_selection.direction": "Dirección",
	"edit.extrude_mesh_selection.direction.outwards": "Hacia afuera",
	"edit.extrude_mesh_selection.direction.average": "Promedio",
	"edit.extrude_mesh_selection.even_extend": "Incluso extender",
	"edit.vertex_snap.align": "Alinear",
	"edit.vertex_snap.align.longest": "Eje más largo",
	"edit.vertex_snap.align.direction": "Dirección desde el pivote",
	"edit.vertex_snap.align.align_axis": "Eje %0",
	"edit.vertex_snap.ignore_axis": "Ignorar eje",
	"codec.common.format": "Formato",
	"codec.image.quality": "Calidad",
	"panel.collections": "Colecciones",
	"modifier_actions.always": "Habilitar Siempre",
	"modifier_actions.unless": "A menos que %0",
	"settings.undo_selections": "Deshacer Selección",
	"settings.undo_selections.desc": "Registrar los cambios de selección como un paso en el historial de deshacer",
	"action.focus_on_selection.zoom": "Zoom para ajustar",
	"display.reference.tooting": "Tocar bocina",
	"settings.selection_tolerance": "Selección de Tolerancia",
	"settings.selection_tolerance.desc": "Tamaño del área en la que se puede hacer click para seleccionar un borde o vértice",
	"action.delete.keep_vertices": "Mantener bordes/vértices",
	"menu.mesh": "Malla",
	"dialog.material_config.subsurface": "Dispersión del subsuelo",
	"dialog.material_config.subsurface_enabled.desc": "Usa el canal alfa del mapa MER para la dispersión del subsuelo",
	"settings.pick_combined_color": "Seleccionar Color Combinado",
	"settings.pick_combined_color.desc": "Selecciona el color combinado de todas las capas en el píxel correspondiente, en lugar del color de la capa activa",
	"action.split_rgb_into_layers": "Dividir canales RGB en capas",
	"action.split_rgb_into_layers.desc": "Divide la textura en capas aditivas, una para cada canal RGB",
	"dialog.project.java_block_version": "Formato de versión",
	"data.spline_mesh": "Ranura",
	"data.billboard": "Cartelera",
	"data.armature": "Armadura",
	"data.armature_bone": "Hueso de armadura",
	"generic.reload": "Recargar",
	"modifier_actions.subtract": "Sustraer",
	"modifier_actions.reduced_intensity": "Afinar",
	"modifier_actions.select_bone": "Seleccionar hueso",
	"modifier_actions.spline_select_multiple_points": "Seleccionar varios puntos o controladores",
	"modifier_actions.move_panel_without_docking": "Mover sin acoplamiento",
	"message.save_all_textures.message": "¿Quieres guardar cada una de las siguientes texturas?",
	"message.save_all_textures.skip": "Omitir",
	"dialog.add_spline.shape": "Forma",
	"dialog.add_spline.shape.segment": "Segmento",
	"dialog.add_spline.shape.square": "Rectángulo",
	"dialog.add_spline.shape.circle": "Círculo",
	"dialog.add_spline.diameter": "Diámetro",
	"dialog.add_spline.sides_tubular": "Segmentos de tubo",
	"dialog.add_spline.sides_radial": "Segmentos de anillo",
	"dialog.add_spline.radius": "Radio del cubo",
	"dialog.add_spline.length": "Longitud",
	"dialog.add_spline.width": "Ancho",
	"dialog.plugins.revoke_permissions": "Revocar permisos",
	"dialog.expression_editor.pretty_print": "Impresión bonita",
	"dialog.expression_editor.minify": "Minificar",
	"dialog.expression_editor.find_replace": "Encontrar/Reemplazar",
	"dialog.create_gif.show_gizmos": "Grabar Gizmos y cuadrícula",
	"dialog.preview_options.title": "Opciones de vista previa",
	"dialog.preview_options.background": "Fondo",
	"dialog.preview_options.background.checkerboard": "Tablero de verificación",
	"dialog.preview_options.background.solid": "Sólido",
	"dialog.preview_options.background.custom_color": "Color personalizado",
	"dialog.preview_options.show_gizmos": "Mostrar Gizmos",
	"dialog.skin.texture_source": "Fuente de la textura",
	"dialog.skin.texture_source.template": "Generar plantilla",
	"dialog.skin.texture_source.load_texture": "Cargar desde Minecraft",
	"dialog.skin.texture_file": "Archivo de textura",
	"dialog.convert_skin.adjust_texture": "Ajustar textura",
	"dialog.settings.clear_profile_value": "Limpiar valores del perfil",
	"layout.section.customize": "Personalizar",
	"layout.theme.configure": "Configurar",
	"layout.color.elevated": "Elevado",
	"layout.color.elevated.desc": "Elementos de la UI elevados, generalmente separados por sombra proyectada",
	"layout.file.watch_changes": "Ver cambios y recargar",
	"settings.autocomplete_code": "Autocompletar Código",
	"settings.autocomplete_code.desc": "Mostrar sugerencias de autocompletado en editores de código",
	"settings.detect_flipbook_textures": "Detectar Texturas Flipbook",
	"settings.detect_flipbook_textures.desc": "Detecta automáticamente texturas animadas tipo flipbook y prévisualízalas como animación",
	"settings.double_click_select_reference": "Seleccionar Imagen de Referencia con Doble Click",
	"settings.double_click_select_reference.desc": "Haga doble clic en la ventana gráfica para seleccionar una imagen de referencia",
	"settings.default_keyframe_interpolation": "Interpolación de Fotogramas Clave Por Defecto",
	"settings.default_keyframe_interpolation.desc": "Seleccione el modo de interpolación de fotogramas clave por defecto",
	"settings.color_picker_style": "Estilo del Selector de Color",
	"settings.color_picker_style.desc": "Seleccione el estilo del selector de color del modo de pintura",
	"settings.export_asset_paths": "Exportar Rutas de Recursos",
	"settings.export_asset_paths.desc": "Seleccione cómo se guardan las rutas de recursos como texturas o animaciones en los archivos .bbmodel",
	"settings.export_asset_paths.relative": "Rutas Relativas",
	"settings.export_asset_paths.absolute": "Rutas Completas",
	"settings.export_asset_paths.both": "Rutas Relativas y Completas (solo texturas)",
	"settings.export_asset_paths.none": "No Exportar",
	"action.slider_spline_resolution": "Resolución de spline %0",
	"action.slider_spline_resolution.desc": "Cambia la resolución spline en el eje %0 (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Segmentos de anillo",
	"action.slider_spline_resolution.v.desc_precision": "Segmentos de tubo",
	"action.slider_spline_radius": "Radio de Spline",
	"action.slider_spline_radius.desc": "Cambia el radio de Spline",
	"action.slider_spline_handle_tilt": "Inclinación del controlador",
	"action.slider_spline_handle_tilt.desc": "Cambia la inclinación del controlador de spline",
	"action.slider_spline_handle_size": "Tamaño del Manejador",
	"action.slider_spline_handle_size.desc": "Cambia el tamaño del controlador de spline",
	"action.blend_mode.lighten": "Iluminar",
	"action.blend_mode.darken": "Oscurecer",
	"action.weight_brush": "Peso del pincel",
	"action.weight_brush.desc": "Pinta los pesos de vértices en mallas para deformaciones de armadura",
	"action.convert_minecraft_skin_variant": "Convertir skin a delgado/ancho",
	"action.convert_minecraft_skin_variant.desc": "Cambia el modelo de la skin entre el clásico modelo ancho (Steve) y el modelo delgado (Alex). Opcionalmente, ajusta automáticamente la textura para que se ajuste al modelo",
	"action.custom_skin_poses": "Poses de skin personalizado",
	"action.custom_skin_poses.desc": "Carga un ajuste preestablecido de pose de skin personalizado",
	"action.custom_skin_poses.update": "Actualizar pose",
	"action.custom_skin_poses.update.desc": "Sobreescribir la pose guardada con la pose actual del modelo",
	"action.add_custom_skin_pose": "Agregar pose de skin",
	"action.add_custom_skin_pose.desc": "Guarda la pose actual del modelo como una pose preestablecida",
	"action.export_stl": "Exportar STL",
	"action.export_stl.desc": "Exportar modelo STL para impresión 3D",
	"action.add_element": "Agregar elemento",
	"action.add_element.desc": "Agrega un nuevo elemento a la lista de tipos de elementos",
	"action.add_spline": "Agregar Spline",
	"action.add_spline.desc": "Agrega una nueva spline",
	"action.add_billboard": "Agregar Cartelera",
	"action.add_billboard.desc": "Agrega una nueva cartelera, un elemento plano que siempre mira hacia la cámara",
	"action.add_armature": "Agregar armadura",
	"action.add_armature.desc": "Agrega una armadura que permite deformar una malla mediante animación",
	"action.add_armature_bone": "Agregar hueso de armadura",
	"action.add_armature_bone.desc": "Agrega un hueso a la armadura",
	"action.search_textures": "Buscar texturas",
	"action.search_textures.desc": "Buscar texturas por nombre",
	"action.search_animations": "Buscar Animaciones",
	"action.search_animations.desc": "Buscar animaciones por nombre",
	"action.spline_selection_mode": "Modo de selección de Spline",
	"action.spline_selection_mode.object": "Objeto",
	"action.spline_selection_mode.handles": "Manejadores",
	"action.spline_render_mode": "Geometría",
	"action.spline_render_mode.mesh": "Malla",
	"action.spline_render_mode.path": "Ruta",
	"action.spline_render_mode.desc": "Qué geometría debe renderizar este spline",
	"action.spline_uv_mode": "Estilo UV",
	"action.spline_uv_mode.length_accurate": "Longitud precisa",
	"action.spline_uv_mode.uniform": "Uniforme",
	"action.spline_uv_mode.per_segment": "Por segmento",
	"action.spline_uv_mode.desc": "Cómo la malla del tubo del spline debe colocar sus UV",
	"action.spline_ring_segments": "Anillo de segmentos",
	"action.spline_ring_segments.desc": "Cuántas subdivisiones tiene esta Spline por anillo de tubo",
	"action.spline_tube_segments": "Segmentos de tubo",
	"action.spline_tube_segments.desc": "Cuántas subdivisiones tiene esta Spline a lo largo de su trayectoria",
	"action.spline_tube_radius": "Radio del tubo",
	"action.spline_tube_radius.desc": "Establece el radio del tubo de la spline",
	"action.spline_display_space": "Espacio de exhibición",
	"action.spline_display_space.desc": "Muestra indicadores de espacio de spline en su ruta",
	"action.spline_handle_mode": "Modo de manejo de spline",
	"action.spline_handle_mode.desc": "Qué modo usar para transformar los manejos de spline",
	"action.spline_handle_mode.aligned": "Alineado",
	"action.spline_handle_mode.free": "Libre",
	"action.spline_handle_mode.mirrored": "Reflejado",
	"action.slider_weight_brush_size": "Tamaño del peso del pincel",
	"action.weight_brush_xray": "Modo rayos X con el peso del pincel",
	"action.weight_brush_xray.desc": "Cuando está habilitado, el peso del pincel afectará a todos los vértices en lugar de solo a los que son visibles en la superficie",
	"action.apply_spline_rotation": "Aplicar rotación",
	"action.apply_spline_rotation.desc": "Reinicia la rotación del elemento de la spline y en su lugar lo aplica a la geometría",
	"action.extrude_spline_selection": "Extruir Spline",
	"action.extrude_spline_selection.desc": "Extruye el manejo seleccionado en todas las splines",
	"action.split_spline": "Dividir Spline",
	"action.split_spline.desc": "Divide la spline en dos splines en el manejo seleccionado",
	"action.divide_spline_curve": "Dividir segmento Spline",
	"action.divide_spline_curve.desc": "Divide el segmento de spline en dos nuevos segmentos con un nuevo manejo en su intersección",
	"action.set_vertex_weights": "Establecer peso de vértices",
	"action.set_vertex_weights.desc": "Establece el peso de los vértices seleccionados a un valor específico en un cierto hueso de armadura",
	"action.calculate_vertex_weights": "Calcular peso de los vértices",
	"action.calculate_vertex_weights.desc": "Asigna automáticamente pesos de vértices en función de la posición de los huesos",
	"action.shelf_alignment": "Alineamiento del estante",
	"action.shelf_alignment.desc": "Selecciona la alineación vertical de los items en el estante",
	"action.shelf_alignment.top": "Alineamiento hacia arriba",
	"action.shelf_alignment.bottom": "Alineamiento hacia abajo",
	"action.view_mode.vertex_weight": "Peso del vértice",
	"action.view_mode.weighted_bone_colors": "Colores de los huesos del vértice",
	"action.create_animation_group": "Crear grupo de animación",
	"action.create_animation_group.desc": "Crea un grupo de animaciones",
	"action.move_graph_keyframes_up": "Mover el gráfico de fotogramas clave hacia arriba",
	"action.move_graph_keyframes_down": "Mover el gráfico de fotogramas clave hacia abajo",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Editor de expresiones",
	"menu.color_picker.picker_type.normal": "Mapa Normal",
	"menu.texture.flipbook_animation": "Animación Flipbook",
	"menu.panel.attach_to": "Adjuntar a",
	"menu.animation.playing": "Reproducir",
	"menu.animation_file.save_as": "Guardar como",
	"menu.animator.quaternion_interpolation": "Interpolación de cuaterniones",
	"edit.extrude_spline_selection.extend": "Extender",
	"edit.divide_spline_curve.position": "Posición",
	"group.bedrock_binding": "Vinculante",
	"group.cem_attach": "Adjuntar CEM",
	"group.cem_model": "Modelo CEM",
	"group.cem_scale": "Escala CEM",
	"cube.rescale": "Reescalar rotación",
	"cube.rescale.desc": "Reescala el cubo para compensar el ángulo de rotación",
	"mesh.shading": "Sombreado",
	"mesh.shading.flat": "Plano",
	"mesh.shading.smooth": "Liso",
	"spline_mesh.cyclic": "Cíclico",
	"spline_mesh.cyclic.desc": "La spline seleccionada debe formar un bucle (Ciclo)",
	"billboard.offset": "Desplazamiento",
	"billboard.facing_mode": "Modo de orientación",
	"billboard.facing_mode.lookat": "Mirar a",
	"billboard.facing_mode.lookat_y": "Mirar a Y",
	"billboard.facing_mode.rotate": "Rotar",
	"billboard.facing_mode.rotate_y": "Rotar Y",
	"armature_bone.connected": "Conectado",
	"reference_image.blueprint": "Plano bloqueado",
	"codec.image.alpha_channel": "Canal alfa",
	"codec.image.animation_fps": "FPS de la animación",
	"panel.palette": "Paleta",
	"panel.keyframe.change_effect_file": "Cambiar archivo de efecto",
	"panel.transform": "Transformar",
	"panel.element.spline_dimensions": "Dimensiones de Spline",
	"display.slot.on_shelf": "Estante",
	"display.reference.shelf": "Estante (todos los slots)",
	"display.reference.shelf_left": "Estante (slot izquierdo)",
	"display.reference.shelf_center": "Estante (slot central)",
	"display.reference.shelf_right": "Estante (slot derecho)",
	"message.newer_project_format_version.title": "Cliente obsoleto",
	"message.newer_project_format_version.message": "Este archivo se guardo en una versión más reciente de Blockbench. Actualize  Blockbench a %0 o posterior para poder abrirlo correctamente",
	"message.load_images.add_layer": "Agregar como capa",
	"message.load_images.category.add_to_project": "Añadir al proyecto",
	"message.load_images.category.new_project": "Nuevo proyecto",
	"message.load_palette.title": "Cargar paleta",
	"message.load_palette.message": "¿Estás seguro que quieres cargar esta paleta? Esto reemplazará tu paleta de colores actual.",
	"dialog.set_vertex_weights.weight": "Peso",
	"dialog.set_vertex_weights.overwrite": "Sobreescribir otros huesos",
	"action.element_render_order.short": "Orden de renderizado",
	"action.element_render_order.desc": "Orden de renderizado de los elementos. Esto puede ayudar a corregir elementos que están ocultos detrás de otros elementos con texturas transparentes. Déjalo en Auto para elementos opacos.",
	"spline.shading.flat": "Plano",
	"spline.shading.smooth": "Liso",
	"spline.shading": "Sombreado",
	"spline.shading.desc": "Cómo se debe sombrear el tubo de esta spline",
	"action.slider_weight_brush_limit": "Límite de peso del pincel",
	"action.slider_weight_brush_limit.desc": "Establece un límite superior para la cantidad de peso que el pincel puede asignar a un vértice",
	"action.weight_brush_blend_mode": "Modo de combinación del peso de los pinceles",
	"action.weight_brush_blend_mode.set": "Establecer",
	"action.weight_brush_blend_mode.add": "Añadir",
	"action.apply_texture_to_elements": "Aplicar textura a los elementos",
	"action.apply_texture_to_elements.desc": "Aplica la textura seleccionada a los elementos seleccionados",
	"menu.panel.reset_size": "Reiniciar tamaño",
	"action.import_layer": "Importar capa",
	"action.import_layer.desc": "Importa archivos de imagen como capas",
	"menu.collection.open_file": "Abrir archivo",
	"layout.version": "Versión",
	"settings.status_bar_transform_sliders": "Transformar controles deslizantes en la barra de estado",
	"settings.status_bar_transform_sliders.desc": "Muestra la barra de herramientas de los controles deslizantes de transformación de la herramienta seleccionada en la barra de estado en lugar de usar el panel Transformar",
	"settings.default_bedrock_format": "Formato Por Defecto de Bedrock",
	"settings.default_bedrock_format.desc": "Selecciona el formato por defecto para cargar los modelos de Minecraft Bedrock cuando no se pueda detectar ningún formato específico a partir del contexto.",
	"settings.limit_brush_opacity_per_stroke": "Limitar la Opacidad del Pincel por Trazo",
	"settings.limit_brush_opacity_per_stroke.desc": "Limite la opacidad que un pincel puede aplicar al valor del control deslizante de opacidad durante cada trazo. Con un pincel suave, este comportamiento puede generar un ligero ruido no deseado.",
	"action.merge_splines": "Fusionar Splines",
	"action.merge_splines.desc": "Fusionar múltiples splines en uno",
	"settings.default_java_block_version": "Versión de Bloque/Item de Java por defecto",
	"settings.default_java_block_version.desc": "Versión de formato por defecto cuando creas nuevos modelos de bloque/item de Java o abres archivos sin formato de versión",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}